export default {
  'Expected Fee Collection (1%)': 'Expected Fee Collection (1%)',
  'Organization Name': 'Organization Name',
  'Organization Setup': 'Organization Setup',
  'Super Admin': 'Super Admin',
  'Total Fee Collection (Approved)': 'Total Fee Collection (Approved)',
  'Total Fee Collection (Declined)': 'Total Fee Collection (Declined)',
  'Total Fee Collection (Pending)': 'Total Fee Collection (Pending)',
  'Total Settled Payments': 'Total Settled Payments',
  abbreviation: 'Abbreviation',
  absence: 'Absence',
  absenceReason: 'Reason for Absence',
  absentDates: 'Absent Dates',
  accept: 'Accept',
  accountAndSettings: 'Account and Settings',
  accounting: 'Accounting',
  accountNumber: 'Account Number',
  acknowledge: 'Acknowledge',
  acknowledged: 'Acknowledged',
  acknowledgedDate: 'Acknowledged Date',
  acknowledgedOverridden: 'Acknowledged/Overridden',
  acknowledgedReceiptText: 'acknowledged receipt of this report on',
  acknowledgeReceiptOfReport: 'Acknowledge Receipt of Report',
  acknowledgeReport: 'Acknowledge Report',
  acknowledgingAs: 'Acknowledging as',
  acknowledgmentExplanation:
    'You are acknowledging that you have received and reviewed this report. This does <b>not require agreement</b>—only confirmation that it has been shared with you.',
  action: 'Action',
  actions: 'Actions',
  active: 'Active',
  activeCampaign: 'Active Campaign',
  activeDays: 'Active Days',
  activeGroupsOnly: 'Active groups only',
  activeGroupsHelpText:
    'A group is considered active if it has a staff member currently assigned to it, or a staff member signed into a room that has a student from this group in attendance.',
  activity: 'Activity',
  activityType: 'Activity type',
  actual: 'Actual',
  actualAmount: 'Actual Amount',
  actualSpaceRatio: 'Actual Space Ratio',
  add: 'Add',
  addAddress: 'Add Address',
  addAttachments: 'Add Attachments',
  addAuthorization: 'Add Authorization',
  addCalendar: 'Add Calendar',
  addDescription: 'Add Description',
  addDomain: 'Add Domain',
  addedAllSpacesMessage: 'You have added all of the spaces.',
  addFramework: 'Add Framework',
  addImmunization: 'Add Immunization',
  additionalChild: 'Additional Child',
  addChild: 'Add Child',
  addMaterial: 'Add Material',
  addMember: 'Add Member',
  addMilestone: 'Add Milestone',
  addNewEvent: 'Add New Event',
  addPaymentInfoBannerMessage:
    'Make sure to add your Preauthorized Payment Information',
  addPendingReportsBannerMessage:
    'You have reports that require acknowledgment',
  addPreauthorizedDebit: 'Add Preauthorized Debit',
  addRegistration: 'Add Registration',
  address: 'Address',
  addSpace: 'Add Space',
  addStaff: 'Add Staff',
  addStudent: 'Add Student',
  addTitle: 'Add title',
  adjustments: 'Adjustments',
  adminScope: 'Admin',
  adminTeam: 'Admin Team',
  admin: {
    learn: {
      dashboard: 'Dashboard',
      plan: 'Plans',
      lesson: 'Lessons',
      report: 'Report',
      setup: 'Setup',
    },
  },
  actualAdminTime: 'Act. Admin Time',
  administeredBy: 'Administered by',
  administrationInstructions: 'Administration Instructions',
  administratorOverride: 'Administrator Override',
  adminNotes: 'Notes (visible to admins only)',
  adminOrStaffMember: 'Admin / Staff',
  adminPayments: 'Admin Payments (Temp)',
  adminStaff: 'Administrative Staff',
  adminViewOnly: 'Admin View Only',
  advanced: 'Advanced',
  afterClearCacheMessage:
    'After clearing the cache and reloading this page, you can use the button below to go back to Home.',
  age: 'Age',
  ageAsOfToday: 'Age as of Today',
  ageDictionaries: 'Age Dictionary',
  ageGroup: 'Age Group',
  ageGroupDictionary: 'Age Group Dictionary',
  ageGroupOptions: {
    zeroToSixMonths: '0–6 M',
    sixToTwelveMonths: '6–12 M',
    twelveToTwentyFourMonths: '12–24 M',
    twentyFourToThirtySixMonths: '2–3 Y',
    thirtySixToFourtyEightMonths: '3–4 Y',
    fourtyEightToSixtyMonths: '4–5 Y',
    kindergarten: 'Kindergarten',
    beforeOrAfterSchool: 'Before/After School',
  },
  ageGroups: 'Age Groups',
  ageOnStartDate: 'Age On Start Date',
  ageRange: 'Age Range',
  ageRangeInMonths: 'Range (in months or grades)',
  ageRangeType: 'Age Range Type',
  ages: 'Ages',
  agreementLink: 'Agreement Link',
  agreements: 'Agreements',
  agreementsAndPolicies: 'Agreements and Policies',
  alias: 'Alias',
  all: 'All',
  allGroups: 'All Groups',
  allAssessmentsApproved: 'All Assessments Approved',
  allAttendeesInSpace: 'All attendees present in space',
  allCaughtUp: 'All Caught Up!',
  allDay: 'All Day?',
  allergiesMedicalConditions: 'Allergies & Medical Conditions',
  allergiesMedicalConditionsName: 'Name of Allergy or Medical Condition',
  allEventsInSeries: 'All events in series',
  allowCreditCards: 'Allow Credit Card Transactions',
  allowParentToRoomStaffMessaging: 'Allow Parent to Room Staff Messaging',
  allowUnauthorizedDeviceAccess: 'Allow Unauthorized Device Access',
  allRoles: 'All Roles',
  allStudents: 'All Students',
  amount: 'Amount',
  amountCharged: 'Amount Charged',
  andXMoreErrors: 'and {count} more errors',
  announcement: 'Announcement',
  announcementHint:
    'Want to message an entire group? Try sending an Announcement from the announcements tab.',
  announcements: 'Announcements',
  annualSalary: 'Annual Salary ($)',
  apply: 'Apply',
  applyDateFilter: 'Apply Date Filter',
  applyToAmount: 'Based On Amount',
  appointment: 'Appointment',
  appropriateAge: 'Appropriate Age',
  approvalRequested: 'Approval Requested',
  approvalStatus: 'Approval Status',
  approvalPending: 'Approval Pending',
  arAging: 'AR Aging',
  approved: 'Approved',
  approveTime: 'Edit/Approve Time',
  archive: 'Archive',
  archivedRates: 'Archived Rates',
  assessmentNoteTooltip: 'Assessment has a note',
  assignedGroups: 'Assigned Groups',
  associateTask: 'Associate Task',
  asterix: '*',
  atLeastOneAdminTimeRequired:
    'At least one administration time is required for regular medication.',
  attatchFiles: 'Attatch Files',
  atteAndJounral: 'Attendance & Journal',
  attendance: 'Attendance',
  attendanceKiosk: 'Attendance Kiosk',
  attendanceKioskNotEnabled: 'Attendance Kiosk is not enabled.',
  attention: 'Attention',
  authGuard: {
    unauthorizedDevice: {
      title: 'This device is not authorized.',
      message: 'Please contact your Admin to authorize the device.',
    },
    setupAccessDenied: {
      title: 'Access Denied',
      message: 'You do not have permission to access this page.',
    },
  },
  authorization: 'Authorization',
  authorizationInfo: 'Authorization Info',
  authorized: 'Authorized',
  authorizeDeviceErrorMessage: 'Error authorizing device',
  authorizeDeviceLabel: 'Authorize this device',
  authorizeDeviceTooltip:
    'Authorize this device to be able to be used by non-admin users.',
  authorizedSponsor: 'Authorized Sponsor',
  authorizedVolunteer: 'Authorized to Volunteer',
  autoAdjustments: 'Auto Adjustments',
  autoBillingSummary: 'Auto Billing Summary',
  autoBilling: 'Auto Billing',
  automation: 'Automation',
  autoPaymentDate: 'Auto Payment Date',
  autoPayments: 'Auto Payments',
  autoRegularTuitionInvoicing: 'Auto Regular Tuition Invoicing',
  available: 'Available',
  avatar: 'Avatar',
  averagingPeriod: 'Averaging Period (In Weeks)',
  back: 'Back',
  backToGroupReport: 'Back to Group Report',
  backToLogin: 'Back to log in',
  balance: 'Balance',
  bankAccount: 'Bank Account',
  bankInfo: 'Bank Info',
  bankName: 'Bank Name',
  bankStatement: 'Bank Statement',
  bankVerificationDocuments: 'Bank Verification Documents',
  basic: 'Basic',
  basicInfo: 'Basic Info',
  bestPhoneNumber: 'Best Phone Number',
  billing: 'Billing',
  billingAmountTooltip:
    'Percentage amounts will be calculated based on the total billing amount including any third party sponsor amounts',
  billingCycle: 'Billing Cycle',
  billingDate: 'Billing Date',
  billingDue: 'Billing Due',
  billingEndDate: 'Billing End Date',
  billings: 'Billings',
  billingStartDate: 'Billing Start Date',
  birthdayfuturecheck: 'Birthday must be a valid date',
  bookingDays: 'Booking Days',
  bookingType: 'Booking Type',
  briefDescription: 'Brief Description',
  broadcast: 'Broadcast',
  broadcastPartialFailure: 'Failed to send to {count} recipient(s)',
  broadcastSentSuccessfully: 'Broadcast sent successfully',
  bulkMessageProcessingMessage: 'Bulk message deliveries may take some time...',
  bulkMessages: 'Bulk Messages',
  bulkMessaging: 'Bulk Messaging',
  bulkRegistrations: 'Bulk Registrations',
  businessInfo: 'Business Info',
  businessName: 'Legal Business Name',
  businessNumber: 'Business Number',
  businessType: 'Business Type',
  bussing: 'Bussing',
  by: 'By',
  calendar: 'Calendar',
  calendarShare: {
    addGroups: 'Add Groups',
    addPeople: 'Add people and groups',
    addSelected: 'Add Selected',
    allGroups: 'All Groups',
    allMembers: 'All Members',
    allStaff: 'All Staff',
    allMembersHelpText:
      'Share this calendar with all portal members (guardians) with view-only access.',
    allStaffHelpText:
      'Share this calendar with all staff members (both office and room staff).',
    allowGroupStaffToEdit: 'Allow group staff to edit',
    calendarsIncluded: 'Calendars included',
    canEdit: 'Can Edit',
    childStatus: 'Child Status',
    copyLink: 'Copy Link',
    createLink: 'Create Link',
    createShareLink: 'Create Share Link',
    createShareLinkForCalendar: 'Create Share Link',
    deleteLink: 'Delete Link',
    deleteShareLink: 'Delete Share Link',
    deleteShareLinkWarning:
      'Are you sure you want to delete this share link? Any calendars currently subscribed to this URL will no longer receive updates.',
    duplicateLinkWarning:
      'A share link with these exact calendars already exists: "{name}". Creating a new link will give you a separate URL.',
    existingShareLinks: 'Existing Share Links',
    group: 'Group',
    groupShareHelpText:
      'Groups share the calendar with all portal members who have children in those groups.',
    guardianAccessNote:
      'This Calendar will be shared with View Only access to all the guardians of the active students within these groups',
    icalDownloadNote:
      'Opening this link will download an ICS file. This file is a snapshot and will not automatically update.',
    icalSubscribeNote:
      'To subscribe to this calendar, import it by URL in your calendar app. Any changes will sync within 24 hours.',
    icalSubscribeNoteShort:
      'Import by URL in your calendar app to subscribe. Changes sync within 24 hours.',
    linkCreatedSuccess: 'Share link created!',
    linkName: 'Link Name',
    linkNamePlaceholder: 'e.g., My Work Calendar',
    membersFound: '{count} members found',
    memberSpecific: 'Member Specific',
    noMembersFound: 'No members found',
    noShareLinkForCalendar: 'No share link exists for this calendar.',
    noShareLinks: 'No share links created yet',
    noSharesYet:
      'No shares yet. Click "Add people and groups" to share this calendar.',
    noStaffFound: 'No staff found',
    officeStaffHelpText: 'All office staff can view or edit this calendar.',
    permission: 'Permission',
    roomStaffHelpText:
      'Room staff in selected groups can view or edit this calendar.',
    searchByName: 'Search by name...',
    searchStaff: 'Search staff...',
    selectCalendarsToShare: 'Select calendars to share',
    selected: '{count} selected',
    selectGroups: 'Select Groups',
    selectMembers: 'Select Members',
    selectStaff: 'Select Staff',
    share: 'Share',
    shareCalendar: 'Share Calendar',
    sharedCalendar: 'Shared Calendar',
    sharedWith: 'Shared With',
    shareLink: 'Share Link',
    shareTokenCreated: 'Share link created successfully',
    shareTokenDeleted: 'Share link deleted successfully',
    shareWithAllMembers: 'Share with all members',
    shareWithAllStaff: 'Share with all staff',
    shareWithOfficeStaff: 'Share with all office staff',
    shareWithRoomStaff: 'Share with room staff in these groups',
    staffAccess: 'Staff Access',
    staffFound: '{count} staff found',
    staffStatus: 'Status',
    unknownCalendar: 'Unknown Calendar',
    unnamedLink: 'Unnamed Link',
    viewOnly: 'View Only',
    viewShareLink: 'View Share Link',
    yourNewShareLink: 'Your New Share Link',
  },
  cancel: 'Cancel',
  cancelEnrollmentButtonLabel: 'Cancel Enrollment',
  cancelEnrollmentConsequences1:
    "The student's slot in the program will be released.",
  cancelEnrollmentConsequences2:
    'This registration group and registration(s) related to the registration group will remain visible but will become read-only.',
  cancelEnrollmentConsequences3:
    'Existing billings related to the registrations will stay and can be updated/allowed to be billed.',
  cancelEnrollmentConsequences4:
    'Registration(s) will no longer appear in the processing page to create billings from but you can still create custom billings and create billings from other non-cancelled registrations.',
  cancelEnrollmentWarning: 'Are you sure you want to cancel this enrollment?',
  cancelNewItem: 'Cancel New Item',
  cancelSync: 'Cancel Sync. Cannot be continued',
  cannotChangeSponsor: 'Can not change sponsor',
  cannotEditMemberTypeTooltipMessage:
    'Cannot change the status of this member because you must always have at least one Legal Guardian and Non-Guardian Emergency Contact on file.',
  cannotEditOthersMessage: 'You can only edit your own messages',
  cannotModifyFieldsSaveWarning:
    'The following fields cannot be modified after saving',
  cannotUseReservedGroupName: 'This name is reserved for unassigned staff',
  capacity: 'Capacity',
  capParentAmount: 'Cap Parent Payment Amount',
  catalog: 'Catalog',
  category: 'Category',
  center: 'Center',
  centerAdmin: 'Center Admin',
  centerAlias: 'Center Alias',
  centerBasic: 'Basic',
  centerDepositNumber: 'Center Deposit #',
  centerEmail: 'Center Email',
  centerFinancials: 'Financials',
  centerInfo: 'Center Info',
  centers: 'Centers',
  centerStaff: 'Center Staff',
  centerTimezone: "Center's Timezone",
  certification: 'Certification',
  certifications: 'Certifications',
  certified: 'Certified',
  certify: 'Certify',
  certifyAll: 'Certify All',
  cfDepositNumber: 'Deposit #',
  changeDate: 'Change Date',
  changePassword: 'Change Password',
  changeRate: 'Change Rate',
  charge: 'Charge',
  chargebackFee: 'Chargeback Fee',
  chargeDeposit: 'Charge Deposit',
  chargedPercentage: 'Charged Percentage',
  chargeNow: 'Charge Now',
  checkAvailability: 'Check Availability',
  checkDates: 'Check Date(s)',
  checkedIn: 'Checked In',
  checkedOut: 'Checked Out',
  checkEmailForConfirmation:
    "Please check your email for a confirmation that will contain <span class='text-bold'>IMPORTANT</span> information, including the required next steps in the registration process.",
  checkNumber: 'Check number',
  checkSpamFolderMessage:
    '*If you do not receive an email, please check your SPAM or Promotions folders',
  checkYourEmail: 'Check your email',
  child: 'Child',
  childInformation: 'Child Information',
  children: 'Children',
  childrenInformation: 'Children Information',
  childrenStepInstruction:
    'Enter the information for each child you are registering. You can add more children if needed.',
  chooseDropOffSpace: 'Choose a drop-off space for {firstName} {lastName}',
  city: 'City',
  class: 'Class',
  classes: 'Classes',
  clear: 'Clear',
  clearAll: 'Clear All',
  clearAllFilters: 'Clear All Filters',
  clearSearch: 'Clear search',
  clickToDownload: 'Click to download',
  clickToOpen: 'Click to open',
  clickToResendPrompt: 'Click to resend',
  clickToViewSeriesMessage: 'Click here to view the entire series.',
  clientMessagingAdminHelp:
    'Messages from center administrators about important matters.',
  clientMessagingAnnouncementsHelp:
    'Announcements and updates from the center for all families.',
  clientMessagingRoomStaffHelp:
    "Messages with your child's room staff and teachers about daily activities.",
  client: {
    onboardingForm: {
      nonPrimaryMemberWaitingMessageBefore:
        'You will be given full access to the portal when the primary member',
      nonPrimaryMemberWaitingMessageAfter: 'fills out the required agreements.',
      nonPrimaryMemberWaitingTitle: 'Limited Access',
      youarealmostthere: 'You are almost there!',
    },
  },
  clientAuthGuardMessage:
    'Please return to the dashboard to complete your registration to view the rest of the portal',
  clientString: 'Client',
  clientView: 'Client View',
  clone: 'Clone',
  clonePlan: 'Clone Plan',
  close: 'Close',
  closeDate: 'Close Date',
  closeMessaging: 'Close messaging',
  closeThread: 'Close thread',
  closeTime: 'Close Time',
  collapseAll: 'Collapse All',
  collapseComponent: 'Collapse component',
  collapseTree: 'Collapse tree',
  collectedInPeriod: 'Payment Collected in Period',
  collectedInPeriodHint:
    'The payments will be calculated based on payments received during the period selected but not necessarily connected to the specific billings.',
  collectionEndDate: 'Collection End Date',
  collectionStartDate: 'Collection Start Date',
  collapse: 'Collapse',
  color: 'Color',
  commonName: 'Common Name',
  communicate: 'Communicate',
  communication: 'Communication',
  companyBankAccount: 'Company Bank Account',
  complete: 'Complete',
  completeConfirmation: 'Are you sure you want to complete this enrollment?',
  compose: 'Compose',
  composeBroadcastMessage:
    'Compose a message to send to all selected recipients',
  conductionDate: 'Conduction Date',
  config: 'Config',
  confirmAccuracy: 'Confirm Accuracy',
  confirmBankInfoMissing: 'Bank Info Missing',
  confirmDelete: 'Are you sure you want to delete this {name}?',
  confirmDeleteTitle: 'Confirm Delete {name}',
  confirmDeletionCalendar: 'Are you sure you want to delete this calendar?',
  confirmDeletionSeries:
    'Are you sure you want to delete all events in this series?',
  confirmDeletionSingle: 'Are you sure you want to delete this event?',
  confirmDeletionTitle: 'Confirm Deletion',
  confirmEnableKiosk: 'Enable Attendance Kiosk',
  confirmEnableKioskMessagePart1:
    'Enabling the Attendance Kiosk feature allows authorized family members to conveniently pick up their children using PIN codes.',
  confirmEnableKioskMessagePart2:
    'Please note that if the kiosk is left unmonitored, there may be potential for misuse.',
  confirmEnableKioskResponsibility:
    'By enabling this feature, you acknowledge that the organization and center assume responsibility for any misuse that may occur.',
  confirmLegalGuardian:
    'I confirm that I am the legal guardian of the child/children.',
  confirmNewPasswordErrorMessage: 'Please confirm your new password',
  confirmPassword: 'Confirm Password',
  confirmSave: 'Confirm Save',
  connectedToBillings: 'Payment Connected to Billings in Period',
  connectedToBillingsHint:
    'The payments will be calculated based on payments received for the specific billings from the period selected but irrespective of the date the payments were made.',
  contactAdminForGroupAssignment:
    'Please contact your administrator to be assigned to a group to view messages.',
  contactInfo: 'Contact Information',
  content: 'Content',
  continue: 'Continue',
  continueToPayment: 'Continue to Payment',
  contributors: 'Contributors',
  copiedToClipboardMessage: 'Copied to clipboard',
  copy: 'Copy',
  copyEmbedCodeTooltipMessage: 'Copy Embed Code',
  copyLinkTooltipMessage: 'Copy Link',
  copyToMarketplace: 'Copy lesson to marketplace',
  copyToMyLessons: 'Copy to my lessons',
  coreLearningFocus: {
    cognitiveAcademicSkills: 'Cognitive & Academic Skills',
    physicalDevelopment: 'Physical Development',
    creativeExpressiveArts: 'Creative & Expressive Arts',
    socialLifeSkills: 'Social-Emotional & Life Skills',
    outdoorEnvironmentalLearning: 'Outdoor & Environmental Learning ',
    inquiryHandsOnLearning: 'Inquiry-Based & Hands-On Learning',
    culturalSocialUnderstanding: 'Cultural & Social Understanding',
    earlyLiteracyAndLanguage: 'Early Literacy & Language',
    mathematicalThinking: 'Mathematical Thinking',
    scienceAndDiscovery: 'Science & Discovery',
    engineeringAndBuilding: 'Engineering & Building (STEM)',
    technologyAndDigitalLiteracy: 'Technology & Digital Literacy',
    grossMotorDevelopment: 'Gross Motor Development',
    fineMotorDevelopment: 'Fine Motor Development',
    sensoryExploration: 'Sensory Exploration',
    musicAndMovement: 'Music & Movement',
    artCreativeExpression: 'Art & Creative Expression',
    dramaticImaginativePlay: 'Dramatic & Imaginative Play',
    socialEmotionalLearning: 'Social-Emotional Learning (SEL)',
    mindfulnessAndWellbeing: 'Mindfulness & Well-Being',
    practicalLife: 'Practical Life & Independence',
    graceAndCourtesy: 'Grace & Courtesy',
    outdoorPlay: 'Outdoor Play & Exploration',
    physicalEducation: 'Physical Education & Movement',
    projectBasedLearning: 'Project-Based Learning',
    loosePartsPlay: 'Loose Parts Play & Open-Ended Exploration',
    culturalCommunityStudies: 'Cultural & Community Studies',
    familyCommunityConnections: 'Family & Community Connections',
  },
  couldNotCreatePasscodeMessage: 'Could not generate one time passcode',
  couldNotFetchCentersMessage: 'Could not fetch centers',
  country: 'Country',
  create: 'Create',
  createAccount: 'Create Account',
  createAndClose: 'Create and Close',
  created: 'Created',
  createLogin: 'Create Login',
  createRefund: 'Create Refund',
  creditCard: 'Credit Card',
  creditCardFixed: 'Credit Card Fixed',
  creditCardPercentage: 'Credit Card Percentage',
  creditMemo: 'Credit Memo',
  credits: 'Credits',
  creditsPer: 'Credits Per',
  creditsType: 'Credits Type',
  creditTo: 'Credit To',
  criminalRecord: 'Criminal Record',
  currentAge: 'Current Age',
  currentCenterHasNotEnabledPublicRegistration:
    'Public registration is currently disabled for this center. To enable it, please ensure that Stripe is connected, or set both the registration and waitlist deposits to $0 in all programs.',
  currentGroup: 'Current Group',
  currentlyIn: 'Currently in: {spaceName}',
  currentProgram: 'Current Program',
  currentRate: 'Current Rate',
  currentRegistration: 'Current Registration',
  currentRegistrations: 'Current Registrations',
  currentStatus: 'Current Status',
  curriculum: 'Curriculum',
  curriculums: 'Curriculums',
  curriculumSetUp: 'Curriculum Set Up',
  customElements: 'Custom Elements',
  customEmail: 'Custom Email',
  customerSetup: 'Customer Setup',
  customFields: 'Custom Fields',
  customForm: 'Custom Form',
  customGender: 'Custom Gender',
  customInfo: 'Custom Information',
  customization: 'Customizations',
  customizedForms: 'Customized Forms',
  cycle: 'Cycle',
  dashboard: 'Dashboard',
  Dashboard: 'Dashboard',
  date: 'Date',
  dateFrom: 'Date From',
  dateMustBeAfterTodayErrorMessage: 'Date of Birth cannot be after today',
  dateOfBirth: 'Date of Birth',
  dateRange: 'Date Range',
  dateSelected: 'Date Selected',
  dateSigned: 'Date Signed',
  dateTo: 'Date To',
  day: 'Day',
  days: 'Days',
  daily: 'Daily',
  daysOfWeek: {
    mo: 'Monday',
    tu: 'Tuesday',
    we: 'Wednesday',
    th: 'Thursday',
    fr: 'Friday',
    sa: 'Saturday',
    su: 'Sunday',
  },
  defaultValue: 'Default Value',
  defaultWage: 'Default Wage',
  defaultWageBoost: 'Default Wage Boost',
  delayed: 'Delayed',
  delete: 'Delete',
  deleteAllOccurances: 'Delete All Occurrences',
  deleteConfirmationDialogMessage:
    'Are you sure you want to delete this item? This action cannot be undone.',
  deleteConfirmationDialogTitle: 'Delete Item',
  deleteJournalConfirmationDIalogMessage:
    'Are you sure you want to delete this journal entry? This action cannot be undone.',
  deleteJournalConfirmationDialogTitle: 'Delete Journal Entry',
  deleteRSVP: 'Delete RSVP',
  deleteRSVPMessage:
    'This is part of a recurring series. Would you like to delete only this occurrence or all occurrences in the series?',
  deleteThisInstance: 'Delete This Instance',
  denyEnrollment: 'Yes, deny this enrollment',
  denyEnrollmentConfirmation: 'Are you sure you want to deny this enrollment?',
  deposit: 'Deposit',
  depositAmount: 'Deposit Amount',
  depositByCreatingInvoice: 'Deposit By Creating Invoice',
  depositDate: 'Deposit Date',
  DepositDate: 'Deposit Date',
  deposited: 'Deposited',
  depositGroup: 'Deposit Group',
  depositNumber: 'Deposit Number',
  depositPayment: 'Deposit Payment',
  depositPaymentProcessing: 'Deposit Payment Processing',
  depositPaymentProcessingMessage:
    "Payment processing. We'll update you when payment is received.",
  depositReceivedMessage:
    'Your deposit has been received. Our team will be in touch soon. We look forward to welcoming you!',
  deposits: 'Deposits',
  description: 'Description',
  developer: 'Developer',
  deselectAll: 'Deselect All',
  details: 'Details',
  didNotReceiveEmailPrompt: "Didn't receive the email?",
  direct: 'Direct',
  directory: 'Directory',
  directoryHub: 'Directory Hub',
  directDepositForm: 'Direct Deposit Form',
  directMessages: 'Direct Messages',
  disabled: 'Disabled',
  disableUnauthorizedDeviceAccess: 'Disable unauthorized device access for',
  discard: 'Discard',
  discount: 'Discount',
  discounts: 'Discounts',
  displayOptions: 'Display Options',
  discoveryTopic: 'Discovery Topic',
  discoveryTopics: 'Discovery Topics',
  dismiss: 'Dismiss',
  document: 'Document',
  domain: 'Domain',
  domainAuth: {
    addCnameRecords: 'Add these CNAME records to your DNS provider:',
    addCustomDomain: 'Add a Custom Domain',
    copyAllRecords: 'Copy All Records',
    customDkimHelp:
      "Most users don't need this. Only check this if you already have 's1' or 's2' records in your DNS, or if your IT team asked you to use a specific selector.",
    dnsPropagationNote:
      'Note: DNS changes can take up to 48 hours to propagate.',
    dnsRecordsVerified:
      'All DNS records verified. Emails from this domain will not be flagged as spam.',
    domainHint: 'Enter domain without www or https://',
    domainPlaceholder: 'example.com',
    emptySubtitle: 'Add your first custom domain above',
    emptyTitle: 'No domains configured yet',
    enterDkim:
      'Enter up to 3 characters (e.g. "org") to use as the selector prefix.',
    exampleDomain: 'yourcenter.com',
    host: 'Host',
    manage: 'Manage',
    noDnsRecords: 'No DNS records available. Try refreshing.',
    pending: 'pending',
    pendingStatus: 'Pending',
    preventSpam: 'Skip individual email verification for your domain',
    publicDomainWarning:
      'You cannot authenticate public email domains like {domain}. Please enter a custom domain you own.',
    removeConfirmMessage:
      'Are you sure you want to remove {domain}? Email addresses under this domain will require individual verification after removal.',
    removeConfirmTitle: 'Remove Domain',
    removeDomain: 'Remove Domain',
    requiresCustomDomain:
      'Requires a custom domain you own (e.g., yourcenter.com)',
    setUp: 'Set Up',
    title: 'Domain Authentication',
    useDkimLabel: 'Use custom DKIM selector',
    verified: 'verified',
    verifiedStatus: 'Verified',
    verifyDnsRecords: 'Verify DNS Records',
    whatIsDescription:
      'Domain authentication allows any email address under your custom domain (like {domain}) to send emails without needing individual verification. This feature requires you to own a custom domain and have access to its DNS settings. Public email domains (Gmail, Outlook, etc.) cannot be authenticated.',
    whatIsTitle: 'What is Domain Authentication?',
    yourDomains: 'Your Domains',
  },
  domains: 'Domains',
  dontHaveAnAccount: "Don't have an account?",
  dosage: 'Dosage',
  download: 'Download',
  draft: 'Draft',
  dropIn: 'Drop In',
  duplicate: 'Duplicate',
  duration: 'Duration',
  edit: 'Edit',
  editCalendar: 'Edit Calendar',
  edited: 'Edited',
  editEvent: 'Edit Event',
  editJournalTitle: 'Edit Journal',
  editOrApprove: 'Edit/Approve',
  editOverride: 'Edit Override',
  editRecurringDetails: 'Edit Recurring Details',
  editSeries: 'Edit Series',
  editSignOutTime: 'Edit Sign Out Time',
  editTime: 'Edit Time',
  education: 'Education',
  effectiveDate: 'Effective Date',
  effectiveDateHint: 'New adjustments will be added starting on this day',
  email: 'Email',
  emailAddress: 'Email Address',
  emailAddressLoginUsernameWarning:
    "If the personal email address has been changed, this won't change the login username until the admin approves.",
  emailAddressUserName: 'Email Address/Username',
  emailAlreadyExists: 'Email already exists in our system',
  emailCheckingAvailability: 'Checking email availability...',
  emailCopied: 'Email Copied to Clipboard',
  emailImageAltText: 'Email image',
  emailIsValid: 'Email is valid',
  emailSent: 'Email Sent',
  emailSentOn: 'Email Sent On',
  emailValidAndAvailable: 'Email is valid and available',
  emailShortcutTooltip: {
    familyName:
      "The family name, followed by the word 'Family'. Ex. Bancroft Family",
    recipientFirstName: 'The first name of the recipient being emailed.',
    recipientLastName:
      'The last name of the person to whom the email is being sent.',
    studentFirstName: 'The first name of the applicable student.',
    studentLastName: 'The last name of the applicable student.',
    adminPortalURL:
      'The URL link for the online portal used to sign in as a staff member.',
    familyPortalURL:
      'The URL link for the online portal used to sign in as a family member.',
    recipientUsername: 'The username of the recipient being emailed.',
    recipientBalanceDue:
      'The balance due for the recipient being emailed, found under their name in the ledger.',
    membersBalanceDue:
      'The sum total of the balance due for all the member <b>and unassigned</b> sponsors of the family, totaled from their names in the ledger.',
    thirdPartiesBalanceDue:
      'The sum total of the balance due for all the third party sponsors of the family, totaled from their names in the ledger.',
    totalFamilyBalanceDue:
      'The sum total of the balance due from all third party AND member/unassigned sponsors of the family combined, totaled from their names in the ledger.',
    staffCrimExpiry:
      "The <i>Criminal Record Check</i> expiry date found in the applicable staff's file.",
    staffIntervExpiry:
      "The <i>Intervention Record</i> expiry date found in the applicable staff's file.",
    staffFirstAidExpiry:
      "The <i>First AId</i> expiry date found in the applicable staff's file.",
    staffReviewDate:
      "The <i>Next Formal Review</i> expiry date found in the applicable staff's file.",
    thirdPartyName_Expiry:
      'List of all third party sponsors for the family and their respective expiry dates, separated by commas.  <b>Only shows future third parties, those without an expiry date and those with a past expiry of 90 days or less.</b>',
  },
  emailSignature: 'Email Signature',
  emailTitle: 'Email Subject',
  emailType: 'Email Type',
  embedCodePrompt: 'Embed the following code snippet:',
  embedFormButtonLabel: 'Embed or share form',
  embedFormUpdatedMessage: 'Embed form updated',
  emergencyContacts: 'Emergency Contacts',
  emergencyMeds: 'Emergency/As Needed',
  employment: 'Employment',
  emptyGradeWarning:
    'No grades for current school/program combination, please add grades in Setup -> Schools',
  emptyPodWarning:
    'No transport groups for current school/grade combination, please add group in Setup -> Transport',
  emptyResult: 'Empty',
  enableBulkMessaging: 'Enable bulk messaging',
  enabled: 'Enabled',
  enablePAD: 'Enable Pre-Authorized Debit (PAD)',
  enablePreAuthPayments: 'Enable Pre-Authorized Credit Card Payments',
  enableSpaceForDropOff: 'Enable space for drop-off',
  enableUnauthorizedDeviceAccess: 'Enable unauthorized device access for',
  endDate: 'End Date',
  endDateAndTime: 'End Date and Time',
  endDateCannotBeAfterExpiryDate: 'End date cannot be after expiry date.',
  endDateCannotBeBeforeStartDate: 'End date cannot be before start date.',
  endNap: 'End Nap',
  endTime: 'End Time',
  endTimeMustBeEarlierThanStartTimeErrorMessage:
    'End time must be after start time.',
  enterEmailErrorMessage: 'Please enter your email',
  enterNewPasswordMessage: 'Please enter your new password',
  enterNewPasswordPrompt: 'Enter your new password',
  enterPinCode: 'Enter PIN code',
  enterPINError: 'Unknown error logging in using PIN.',
  enterYourEmail: 'Enter your email',
  error: { onlyNumbersAllowed: 'Only valid numbers are allowed' },
  errorDisplayingPIN: 'Error displaying PIN',
  errorLoadingReport: 'Error loading report',
  etransfer: 'E-Transfer',
  etransferFixed: 'E-Transfer Fixed',
  etransferPercentage: 'E-Transfer Percentage',
  event: 'Event',
  eventDate: 'Event Date',
  eventDescription: 'Event Description',
  events: 'Events',
  eventTitle: 'Event Title',
  excludedDates: 'Excluded Dates',
  existingMember: 'Existing Member',
  existingStudent: 'Existing Student',
  exitBulkMessaging: 'Exit bulk messaging',
  exitKioskCredentialsPrompt:
    'To exit Attendance Kiosk mode, please enter the credentials of an authorized user with the role of Center Admin or Org Admin.',
  exitKioskMode: 'Exit Kiosk Mode',
  expand: 'Expand',
  expandAll: 'Expand All',
  expandToFullPage: 'Expand to full page',
  expandTree: 'Expand tree',
  expected: 'Expected',
  expectedAmount: 'Expected Amount',
  expiresAt: 'Expires At',
  expiryDate: 'Expiry Date',
  expiryDateCannotBeBeforeEndDate: 'Expiry date cannot be before end date.',
  explainOverrideHint:
    "Explain why you're overriding (e.g., parent was called and refused to sign)",
  exportedOn: 'Exported on',
  exportToPdf: 'Export to PDF',
  externalBalance: 'Third Party Bal.',
  externalName: 'External Name',
  failed: 'Failed',
  failedFee: 'Failed Fee',
  failedFeeRate: 'Failed Fee Rate',
  failedPaymentPenalty: 'Failed Payment Penalty',
  failedToDeleteMemberMessage: 'Failed to delete member.',
  failedToDeleteStaffMessage: 'Failed to delete staff.',
  failedToDeleteStudentMessage: 'Failed to delete student.',
  failedToLoadAcknowledgments: 'Failed to load acknowledgments',
  failedToOverrideJournalAcknowledgment:
    'Failed to override journal acknowledgment',
  failedToSendTo: 'Failed to send to:',
  families: 'Families',
  family: 'Family',
  familyAndChildren: 'Family and Children',
  familyInfo: 'Family Info',
  familyMember: 'Family Member',
  familyName: 'Family',
  featureFlags: 'Feature Flags',
  fee: 'Fee',
  feeCollection: 'Fee Collection',
  feePayments: 'Fee Payments',
  file: 'File',
  files: 'Files',
  fileErrorMessage: 'Unable to load file',
  fileErrorTitle: 'File Error',
  fileExplorer: 'Files',
  fileInvalidOrMissing: 'Invalid or missing file.',
  fileName: 'File Name',
  fileNotFound: 'File not found',
  fileReadError: 'Error reading file.',
  fileSize: 'File Size',
  fileTooLarge100MB: 'Exceeds max file size of 100MB.',
  filter: 'Filter',
  filterAttendees: 'Search Attendees',
  filterByGroup: 'Filter by group',
  filterByGroups: 'Filter by groups',
  filters: 'Filters',
  filterSpaces: 'Search Spaces',
  filterStaff: 'Search Staff',
  filterStudents: 'Search Students',
  finance: 'Finance',
  finances: 'Finances',
  financial: 'Financial',
  financialInfo: 'Financial Info',
  finish: 'Finish',
  finishAnyway: 'Exit Anyway',
  finishAt: 'Finish At',
  firstAid: 'First Aid',
  firstName: 'First Name',
  fixed: 'Fixed($)',
  fixedAmount: 'Fixed Amount',
  focusArea: 'Focus Area',
  focusAreaGroupDescription:
    'Monitor group progress across all focus areas based on completed lessons',
  focusAreaGroupTitle: 'Focus Area Report For Groups',
  focusAreaProgress: 'Focus Area Progress',
  focusAreaReport: 'Focus Area Report',
  focusAreaReports: 'Focus Area Reports',
  focusAreaStudentDescription:
    'Monitor student progress towards focus areas based on completed lessons',
  focusAreas: 'Focus Areas',
  focusAreaStudentTitle: 'Focus Area Report For Students',
  followUp: 'Follow Up',
  forgotPasswordPrompt: 'Forgot password?',
  forMe: 'For Me',
  forms: 'Forms',
  forParents: 'For Parents',
  framework: 'Framework',
  frameworks: 'Frameworks',
  freezePayments: 'Freeze Payments',
  frequency: 'Frequency',
  from: 'From',
  fromDate: 'From Date',
  fromDateCannotBeAfterToDate: 'From date cannot be after the To date.',
  fromMe: 'From Me',
  fullDetails: 'Full Details',
  fullName: 'Full Name',
  futureRegistrations: 'Future Registrations',
  gender: 'Gender',
  general: 'General',
  generalInformation: 'General Information',
  goBack: 'Go back',
  goHome: 'Go Home',
  grade: 'Grade',
  gradeRange: 'Grade Range',
  grades: 'Grades',
  graduateRate: 'Graduate Rate',
  group: 'Group',
  groupAsOfDate: 'Group As Of Date',
  groupOverride: 'Group Override',
  groups: 'Groups',
  groupSize: 'Group Size',
  growthIndicator: 'Growth Indicator',
  growthIndicators: 'Growth Indicators',
  guardian: 'Guardian',
  guardianOne: 'Guardian One',
  guardians: 'Guardians',
  guardianSignature: 'Guardian Digital Signature of Permission',
  guardianStepInstruction:
    'Enter the legal guardian information for the family. This person will be the primary contact and responsible for the registration.',
  health: 'Health',
  healthCareNumber: 'Health Care Number',
  healthSymptoms: 'Health Symptoms',
  hide: 'Hide',
  hiddenOnPortal: 'Hide Invoices on Portal',
  hideBankInfoLabel: 'Hide bank info',
  hideHiddenRecords: 'Hide Hidden Records',
  hidePIN: 'Hide PIN',
  highAge: 'High Age',
  highAgeMonths: 'High Age (months)',
  highAgeValidationError: 'High Age cannot be lower or equal to Low Age.',
  highGrade: 'High Grade',
  highGradeValidationError: 'High grade cannot be lower than low grade.',
  highRatio: 'High Ratio',
  hint: {
    filtering: 'Hint: Filtering for students{status}{dateRange}.',
    withStatus: " with '{status}' status",
    withDateRange: ' at some point during the period {from} to {to}',
    withoutDateRange: '',
  },
  history: 'History',
  holidays: {
    addHoliday: 'Add Holiday',
    archiveYear: 'Archive Year',
    customHolidays: 'Custom Holidays',
    customHolidaysOnly: 'Custom Holidays Only',
    copyCustomHolidaysFromYear: 'Copy Custom Holidays from Year',
    copyFromAnotherYear: 'Copy from Another Year',
    editHoliday: 'Edit Holiday',
    fromYear: 'From Year',
    holidayCalendar: 'Holiday Calendar',
    holidayHours: 'Holiday Hours',
    holidayName: 'Holiday Name',
    holidays: 'Holidays',
    loadHolidays: 'Load Holidays',
    loadPublicHolidays: 'Load Public Holidays',
    regional: 'Regional',
    selectedHolidays: 'Selected Holidays',
    statutory: 'Statutory',
    statutoryHolidayReadOnly:
      'Statutory holidays cannot be deleted, only toggled on/off',
    statutoryHolidays: 'Statutory Holidays',
  },
  homeSpace: 'Home Space',
  hourlyRate: 'Hourly Rate ($)',
  howToManage: 'How To Manage',
  iAm: 'I am a/an...',
  image: 'Image',
  immunization: 'Immunization',
  immunizationAreUpToDate: "'s immunizations are up to date",
  immunizationRecord: 'Immunization Record',
  immunizationRecordFileUrl: 'Immunization Record File',
  immunizationsAreCurrent: 'Immunizations Are Current?',
  importantLinks: 'Important Links',
  importData: 'Import Data',
  importDataType: 'Import Data Type',
  incident: 'Incident',
  includeAllStaffQuestion: 'Include All Staff?',
  includedPayments: 'Included Payments',
  includeDropIn: 'Include Drop In',
  includeUnreadMessages: 'Include unread messages',
  includeWaitlisted: 'Include Waitlisted',
  incorrectPasscodeMessage: 'The code entered is incorrect',
  info: 'Info',
  infoChanges: 'Info Changes',
  infoChangesSavedBannerMessage:
    'Recent changes are saved and are awaiting admin approval.',
  infoTags: 'Info Tags',
  initialize: 'Initialize',
  institutionNumber: 'Institution Number',
  interactions: 'Interactions',
  internal: 'Internal',
  interventionCheck: 'Intervention Check',
  inUseRates: 'In Use Rates',
  invalidCharacters: 'Only lowercase letters, numbers, -, and _ are allowed',
  invalidEmail: 'Must be a valid email address',
  invalidPIN: 'Invalid PIN.',
  invoice: 'Invoice',
  invoiceAmount: 'Invoice Amount',
  invoiceAmountTooltip:
    'Percentage amounts will be calculated based only on the invoiced amount for this sponsor, excluding other sponsors amounts on the billing',
  invoiceNumber: 'Invoice Number',
  invoicePeriodEnd: 'Invoice Period End',
  invoicePeriodStart: 'Invoice Period Start',
  invoices: 'Invoices',
  invoicesAndCreditMemos: 'Invoices & Credit Memos',
  invoiceStatus: 'Invoice Status',
  invoiceType: 'Invoice Type',
  isChildNameOnLabel: 'Name On Label',
  isDefault: 'Is Default',
  isFixed: 'Is Fixed',
  isFlagged: 'Is Flagged',
  isInOriginalContainer: 'Original Container',
  isOvernight: 'Overnight Mode',
  isPrescribedByPhysician: 'Prescribed By Physician',
  isSchoolRequired: 'School Required',
  jobInfo: 'Job Information',
  journal: 'Journal',
  journalAcknowledgmentOverriddenSuccessfully:
    'Journal acknowledgment overridden successfully',
  journalChangesWarning:
    "Changes made when editing a journal of type 'Health' or 'Incident' won't appear until the admin approves.",
  journalDate: 'Journal Date',
  journalMedicationHint: 'There are no emergency/as needed medications on file',
  journalUploadedImageAltText: 'Uploaded image',
  keyImageAltText: 'Key image',
  kinderProgram: 'Kinder Program',
  kiosk: 'Kiosk',
  kioskSignInCompleteMessage:
    'Thank you! Drop-off/pick-up is complete, you’re all set to go.',
  last: 'Last',
  lastBillingDate: 'Last Billing',
  lastContacted: 'Last Contacted',
  lastName: 'Last Name',
  lastStatusChange: 'Last Status Change',
  learn: 'Learn',
  learning: 'Learning',
  learningOutcome: 'Learning Outcome',
  learningOutcomes: 'Learning Outcomes',
  ledger: 'Ledger',
  legacyMessage: 'Legacy message',
  legacyMessageHelp:
    'This message was sent from the old system. Replies will be sent to both the room and admin conversation threads for this member.',
  legalGuardianConfirmationRequired:
    'You must confirm that you are the legal guardian.',
  legalName: 'Legal Name',
  lesson: 'Lesson',
  lessonLibrary: 'Lesson Library',
  lessonName: 'Lesson Name',
  lessonNumber: 'Lesson #',
  lessonPlan: 'Weekly Plan',
  lessons: 'Lessons',
  license: 'License',
  licenseType: 'License Type',
  licensingInfo: 'Licensing Info',
  liveWith: 'Lives With',
  loadEarlierMessages: 'Load earlier messages',
  loadingMoreReports: 'Loading more reports...',
  location: 'Location',
  locationMessagesGroup: { inUseError: 'Cannot delete location(s) in use' },
  locationOptions: {
    classroom: 'Classroom',
    gym: 'Gym',
    outdoorSpace: 'Outdoor Space',
    offsite: 'Offsite',
    other: 'Other',
  },
  locations: 'Locations',
  login: 'Login',
  loginCredentialsInvalidMessage: 'Email or password is invalid',
  loginEmail: 'Login/Reply To Email',
  logout: 'Logout',
  lowAge: 'Low Age',
  lowAgeMonths: 'Low Age (months)',
  lowAgeValidationError: 'Low Age cannot be higher or equal to High Age.',
  lowGrade: 'Low Grade',
  lowGradeValidationError: 'Low grade cannot be higher than high grade.',
  lowRatio: 'Low Ratio',
  main: 'Main',
  makePayment: 'Make payment',
  makeRecurring: 'Make Recurring',
  manuallyConfirmParentAware:
    'Manually confirm that the parent was made aware of this',
  markAsUnread: 'Mark as unread',
  markAsUrgent: 'Mark as urgent',
  marketing: 'Marketing',
  materialName: 'Material Name',
  materialsNeeded: 'Materials Needed',
  maxCapacity: 'Max Capacity',
  maxChildren: 'Max Children',
  maximum: 'Maximum',
  maxTeamSize: 'Max Size',
  meal: 'Meal',
  mealAdjustments: 'Meal Adjustments',
  meals: 'Meals',
  mealService: 'Meal Service',
  mealsService: 'Meals Service',
  mediaLibrary: {
    selectedFileAlt: 'Selected file',
    changeFile: 'Change File',
    addFile: 'Add File',
    uploadYourOwnFile: 'Upload Your Own File',
    uploading: 'Uploading...',
    uploadAFile: 'Upload A File',
    chooseFromLibrary: 'Or Choose From Library',
    searchPhotos: 'Search Photos',
    addToLibrary: 'Add to library',
    fileAlt: 'File {index}',
    noFilesAvailable: 'No files available',
    photoAlt: 'Photo {index}',
    noPhotosAvailable: 'No photos available',
    dragDropOrSelectMultiple: 'Drag & drop or select multiple',
    orDragAndDrop: 'or drag & drop',
    confirmDeleteMessage:
      'Are you sure you want to delete this file? This action cannot be undone.',
    scopeHelper: 'Choose where new files will be stored',
    scopeGlobal: 'Global library',
    scopeOrg: 'Organization library',
    scopeUser: 'My library',
    currentScopePrefix: 'Destination:',
    scopeAll: 'All libraries',
    noFilesForScope: 'No files available',
  },
  medicalAndEmergencyDetails: 'Medical and Emergency Details',
  medication: 'Medication',
  medicationAdministrationDisclaimer:
    '*This medication is only to be administered according to the directions labeled on the original container.',
  medicationForm: 'Medication Form',
  medicationGivenDateTime: 'Medication Given DateTime',
  medicationName: 'Medication Name',
  medicationType: 'Type',
  member: 'Member',
  memberInfoChangesLabel: 'Member Info Changes',
  memberPaymentInfoChangesLabel: 'Member Payment Info Changes',
  memberPaymentInfoChangesTypes: {
    addedBankInfo: 'Added Bank Info',
    editedBankInfo: 'Edited Bank Info',
    deletedBankInfo: 'Deleted Bank Info',
    addedCreditCard: 'Added Credit Card',
    modifiedCreditCard: 'Modified Credit Card',
    deletedCreditCard: 'Deleted Credit Card',
    addCustomEmail: 'Added Custom Email',
    modifyCustomEmail: 'Modified Custom Email',
    deletedCustomEmail: 'Deleted Custom Email',
  },
  memberPINLabel: 'Kiosk PIN',
  members: 'Members',
  memo: 'Memo',
  merchantFee: 'Merchant Fee',
  merchantFeeAmount: 'Merchant Fee Amount',
  merchantFeeDescription:
    'Indicate the merchant fee percentage you wish to charge sponsors automatically, for each transaction type.',
  merchantFeePassThroughAmount: 'Merchant Fee Pass Through Amount',
  message: 'Message',
  messageCenter: 'Message Center',
  messages: 'Messages',
  messageSentSuccessfully: 'Message Sent Successfully!',
  messagesGroup: {
    fail: 'Oops, failed',
    internalError: 'Oops! We are experiencing an error in the server',
    success: 'Success',
    unknownError: 'Oops! We are having an unknown error',
    networkError: 'Oops! Internet connection was lost',
    forbidden: "Oops! Looks like you don't have permission to do that",
    pendingRegistration: 'Available - Payment Required: ',
    waitlistedRegistration: 'Program Full - Join Waitlist: ',
  },
  messagingAs: 'Messaging as',
  messaging: 'Messaging',
  method: 'Method',
  middleName: 'Middle Name',
  milestone: 'Milestone',
  milestones: 'Milestones',
  minChildren: 'Min Children',
  minimize: 'Minimize',
  minimum: 'Minimum',
  minutes: 'Minutes',
  missingCenterBankInfoWarning:
    'You have not entered banking information for your center. Without banking information you will not be able to process family payments or deposit them to your bank account.',
  missingOnboardingInformation: 'Missing Onboarding Information',
  mixedTeamRatioRules: 'Mixed Ratio',
  mobileOutdated: 'Please update your app to the latest version.',
  modifiedDates: 'Modified Dates',
  month: 'Month',
  monthly: 'Monthly',
  months: 'Months',
  more: 'more',
  moreOptions: 'More options',
  moveActivity: 'Move Activity',
  moveDown: 'Move Down',
  moveMultiplePeopleConfirmationMessage:
    'Are you sure you want to move {count} people out of the {fromSpaces} into the {toSpace} space?',
  moveOnePersonConfirmationMessage:
    'Are you sure you want to move 1 person out of the {fromSpaces} into the {toSpace} space?',
  moveTo: 'Move To',
  moveToBlob: 'Move to {blobName}',
  moveUp: 'Move Up',
  multipleAccountsDetected:
    'You have accounts in multiple centers, which one would you like to access?',
  mustProvideEmail: 'Must provide a personal email for username',
  mutedCalendars: 'Muted Calendars',
  muteNotifications: 'Mute Notifications',
  myCalendars: 'My Calendars',
  myGroup: 'My Group',
  myHours: 'My Hours',
  myPlans: 'My Plans Only',
  myself: 'Myself',
  name: 'Name',
  nameOrDescription: 'Name or Description',
  nappers: 'Nappers',
  napping: 'Napping',
  new: 'New',
  newAnnouncement: 'New Announcement',
  newDirectMessage: 'New direct message',
  newEvent: 'New Event',
  newFolder: 'New Folder',
  newItem: 'New Item',
  newMember: 'New Member',
  newMessage: 'New Message',
  newMessages: 'New Messages',
  newPublicRegistration: 'New Public Registration',
  newStudent: 'New Student',
  next: 'Next',
  nextArrow: 'Next >',
  nextDueDate: 'Next Due Date',
  nextFormalReview: 'Upcoming Formal Review',
  nextProgram: 'Next Program',
  no: 'No',
  noAnnouncements: 'No announcements',
  noAssessmentsRecorded: 'No assessments recorded',
  noAttendeesInTeam: 'No attendees in team',
  noDataFound: 'No data found',
  none: 'None',
  noPlans: 'No Plans',
  addAttendeeTooltip: 'Add attendee to team',
  addAssessment: 'Add Assessment',
  addFirstAttendeeToTeam: 'Add the first attendee to {name}',
  noAccountsDetected:
    'No accounts found with the entered email address, please contact your center to setup an account.',
  noAllocation: 'No Allocation',
  noAvailableSpaces:
    'No spaces are currently available for drop-off. Please reach out to your center for assistance.',
  noAvailableStudents:
    'No registered students are currently available for drop-off or pick-up. Please check with your center if you need assistance.',
  noChangesToApplyToMember:
    'No changes to apply because the proposed changed values has already been applied to the member.',
  noChangesToApplyToStudent:
    'No changes to apply because the proposed changed values has already been applied to the student.',
  noConversations: 'No conversations',
  noCurrentActivities: 'No Current Activities',
  noCurrentRegistrations: 'No Current Registrations',
  noDirectMessages: 'No direct messages',
  noFamiliesFound: 'No families found',
  noFileAvailable: 'No File available to download',
  noFilesAvailable: 'No Files Available',
  noGroupsFound: 'No groups found',
  noJournalSelectedForOverride: 'No journal selected for override',
  noMatchingReports: 'No Matching Reports',
  noMemberPIN: 'No PIN',
  noMessages: 'No messages',
  noMessagesYet: 'No messages yet',
  noNotes: 'No notes',
  noNotifications: 'You have no notifications.',
  notifications: 'Notifications',
  noOfChildrenInSpace: 'No. of Children in Space',
  noOfStaffInSpace: 'No. of Staff in Space',
  noOptions: 'No Options',
  noOutcomes: 'No Outcomes',
  noTitle: 'No title',
  signOut: 'Sign Out',
  noActiveGroupsAssigned:
    "You don't have any active groups assigned. You can also gain temporary access by supervising students in a space. Contact your administrator to be added to a group.",
  noAnnouncementsYet: 'No announcements yet',
  noOverlappingAges:
    'No groups setup that all selected students can register in',
  noPaymentRequired: 'No payment required - Registration complete!',
  noRecentActivity: 'No recent activity',
  noRegistrations: 'No registrations',
  noReportsRequireAcknowledgment:
    'No reports require acknowledgment at this time.',
  noReportsToDownload: 'No reports to download',
  noResults: 'No Results',
  noSchoolPickupDates: 'No School Pickup Dates',
  noSearchResults: 'No messages found',
  noSpaces: 'No spaces are allowed',
  noStudentsAssociatedWithFamily:
    'No students are associated with this family.',
  noStudentsFound: 'No Students Found',
  noStudentsSignedInTitle: 'No Students Signed In',
  noStudentsSignedInMessage:
    "You haven't signed in any students yet. Please tap on each student you want to sign in/out, then click Finish.",
  noSuitableFrequency: 'No suitable frequency',
  noSuitableProgram: 'No suitable program',
  notAcknowledged: 'Not acknowledged',
  notAnAdminPrompt: 'Not an admin or staff member?',
  notAnParentPrompt: 'Not a parent or family member?',
  notAssignedToGroups: 'You are not assigned to any groups',
  notAuthorizedToExistKiosk:
    'User has insufficient permissions to exit Attendance Kiosk.  Only users with the Center Admin or Org Admin role are allowed to exit.',
  notes: 'Notes',
  notesCharacterLimit: 'Notes must be 500 characters or less',
  notFoundMessage: 'Oops. The page you are looking for does not exist.',
  notFoundTitle: 'Page Not Found',
  notificationRules: {
    none: 'Do not notify',
    atTimeOfEvent: 'At the time of the event',
    fiveMinutesBefore: '5 minutes before',
    fifteenMinutesBefore: '15 minutes before',
    thirtyMinutesBefore: '30 minutes before',
    oneHourBefore: '1 hour before',
    twoHoursBefore: '2 hours before',
    oneDayBefore: '1 day before',
  },
  learnSettings: {
    title: 'Learn Settings',
    description: 'Configure settings for the learning module',
    loading: 'Loading settings...',
    saved: 'Settings saved',
    requireApproval: 'Require Approval',
    requireApprovalDescription:
      'Require administrative approval of content made by room staff prior to it being available to parents',
    lessons: 'Lessons',
    lessonsDescription:
      'Require administrative approval of lessons made by room staff prior to them being available to parents',
    weeklyPlans: 'Weekly Plans',
    weeklyPlansDescription:
      'Require administrative approval of weekly plans made by room staff prior to them being available to parents',
    assessments: 'Assessments',
    assessmentsDescription:
      'Require administrative approval of assessments made by room staff prior to them being available to parents',
  },
  notificationSettings: {
    allCenters: 'All Centers',
    allCentersWillReceivePush: 'All centers will receive push notifications',
    centerFilter: 'Center Filter',
    centerFilterDescription:
      'Configure notification settings for all centers or select a specific center.',
    changesSavedAutomatically: 'Changes saved automatically',
    chooseWhenToBeNotified: 'Choose when and how to be notified',
    chooseWhenToBeNotifiedDescription:
      "Select push and in-app notifications you'd like to receive",
    disabledForAllCenters: 'Disabled for all centers',
    enabledForAllCenters: 'Enabled for all centers',
    enabledForCenters: 'Enabled for: {centers}',
    enabledForCount: 'Enabled for {count} centers',
    inAppNotifications: 'In-App Notifications',
    inAppNotificationsDescription: 'Notifications in the notification panel',
    loadingPreferences: 'Loading notification preferences...',
    managePreferences: 'Manage your notification preferences',
    messagingNotifications: 'Messaging Notifications',
    messagingNotificationsDescription:
      'Configure how you receive message notifications',
    mobilePushNotifications: 'Mobile Push Notifications',
    mobilePushNotificationsDescription: 'Push alerts on your mobile devices',
    notificationTypeDisabledGlobally: 'Notification type disabled globally',
    pushDisabledForAllCenters: 'Push notifications disabled for all centers',
    pushDisabledForCenters: 'Push notifications disabled for: {centers}',
    pushEnabledForCount:
      'Push notifications enabled for {count} of {total} centers',
    pushNotificationsForCenterDescription:
      'Enable or disable push notifications for this center. When enabled, this center will receive push notifications for globally active notification types.',
    selectCenter: 'Select Center',
    showCrossCenterToast: 'Cross-Center Message Toasts',
    showCrossCenterToastDescription:
      'Show a toast notification when you receive a message from a different center',
    showMessageBadge: 'Message Badge',
    showMessageBadgeDescription:
      'Show unread count badge on the messaging icon',
    showRegularToast: 'Regular Message Toasts',
    showRegularToastDescription:
      'Show a toast notification when you receive a new message',
    showUrgentToast: 'Urgent Message Toasts',
    showUrgentToastDescription:
      'Show an urgent toast notification for urgent messages. If disabled, urgent messages will follow regular toast settings.',
    testOnly: 'Test Only',
  },
  notifyThoseWithAccess:
    'Notify those with Calendar Access via In-App Notification',
  notOverridden: 'Not overridden',
  noWorriesResetPasswordMessage:
    "No worries, we'll send you reset instructions.",
  number: 'Number',
  numberOfChargbackPayments: '# Chargeback Payments',
  numberOfFailedPayments: '# Failed Payments',
  numberOfPayments: 'Number Of Payments',
  occupation: 'Occupation',
  occupationOptions: 'Occupation Options',
  occurrenceDaily: 'Occurs every {interval} days until:',
  occurrenceDailySingle: 'Occurs every day until:',
  occurrenceMonthlyRanked:
    'Occurs on the {rank} {day} of every {interval} months until:',
  occurrenceMonthlyRankedSingle:
    'Occurs on the {rank} {day} of every month until:',
  occurrenceMonthlySpecific:
    'Occurs on day {day} of every {interval} months until:',
  occurrenceMonthlySpecificSingle: 'Occurs on day {day} of every month until:',
  occurrenceWeekly: 'Occurs every {interval} weeks on {days} until:',
  occurrenceWeeklySingle: 'Occurs every week on {days} until:',
  occurrenceYearlyRanked:
    'Occurs every {interval} years on the {rank} {day} of {month} until:',
  occurrenceYearlyRankedSingle:
    'Occurs every year on the {rank} {day} of {month} until:',
  occurrenceYearlySpecific:
    'Occurs every {interval} years on {month} {day} until:',
  occurrenceYearlySpecificSingle: 'Occurs every year on {month} {day} until:',
  occurrences: '{count} occurrences',
  officeStaff: 'Office Staff',
  onboarding: 'Onboarding',
  onboardingEnrollment: 'Onboarding Enrollment',
  onDayOfMonth: 'On day {day}',
  oneTime: 'One Time',
  oneTimePasscodeSentMessage:
    'A one time passcode has been sent to {email} if it exists.',
  onRankedDayOfMonth: 'On the {rank} {day} of {month}',
  onRankedDayOfWeek: 'On the {rank} {day}',
  onSpecificDate: 'On {date}',
  open: 'Open',
  openDate: 'Open Date',
  openDays: 'Open Days',
  openInDialog: 'Open in dialog',
  openTime: 'Open Time',
  opportunities: 'Opportunities',
  opportunity: 'Opportunity',
  optional: '(Optional)',
  or: 'or',
  orgAdmin: 'Org Admin',
  orgAlias: 'Org Alias',
  orgAndCenter: 'Org and Center',
  organization: 'Organization',
  orgBasic: 'Basic',
  orgLogoAltText: 'Org logo',
  original: 'Original',
  other: 'Other',
  otherContacts: 'Other Contacts',
  otherTasks: 'Other Tasks',
  outdatedHeader: 'Your version of the app is outdated',
  outsideProgram: 'Services Outside of Program',
  outstand: 'Outstand',
  outstanding: 'Outstanding',
  outstandingBalance: 'Outstanding Balance',
  outstandingInformationDueNow: 'Outstanding Information - Due Now',
  overlappingAgeRangeError:
    'The age range overlaps with an existing range: {lowAge}-{highAge} months.',
  overlappingGradeRangeError:
    'The grade range overlaps with an existing range: {lowGrade} - {highGrade}.',
  overridden: 'Overridden',
  overriddenBy: 'Overridden by',
  override: 'Override',
  overrideAcknowledgment: 'Override Acknowledgment',
  overrideDate: 'Override Date',
  overrideNotes: 'Override Notes',
  overtimeOptions: 'Overtime Options',
  overview: 'Overview',
  ownerInfo: 'Owner Info',
  owners: 'Owners',
  pad: 'PAD',
  padExplanation:
    "Enabling PAD allows the center to debit your account when an invoice is due, so you don't have to worry about late payments.",
  padFixed: 'Pad Fixed',
  padlockImageAltText: 'Padlock image',
  padPercentage: 'Pad Percentage',
  parentAmount: 'Parent Amount',
  parentCap: 'Parent Cap',
  parentOrFamilyMember: 'Parent / Family',
  parents: 'Parents',
  passCodeGenerated: 'One time passcode generated, please check your email',
  password: 'Password',
  passwordDoesNotMatchErrorMessage: 'Password does not match',
  passwordErrors: {
    empty: 'Password cannot be empty.',
    length: 'Password must be between 8 and 32 characters long.',
    invalidCharacters: 'Password contains invalid characters.',
    criteria:
      'Password must contain at least three of the following: lowercase letters, uppercase letters, numbers, and symbols.',
  },
  passwordRequirements: {
    characters: 'Allowed characters:',
    criteriaTitle:
      'Password must be between 8 and 32 characters long and must contain at least three of the following:',
    lowercase: 'Lowercase letters (a-z)',
    uppercase: 'Uppercase letters (A-Z)',
    numbers: 'Numbers (0-9)',
    symbols: 'Symbols ({symbols})',
  },
  pastRegistrations: 'Past Registrations',
  payDeposit: 'Pay Deposit',
  payment: 'Payment',
  paymentAmount: 'Payment Amount',
  paymentDue: 'Payment Due',
  paymentFailed: 'Payment Failed',
  paymentFailedMessage:
    'Payment failed to process. Please contact administrator.',
  paymentInfo: 'Payment Info',
  paymentMethod: 'Method',
  paymentMethods: 'Payment Methods',
  paymentNumber: 'Payment Number',
  paymentOrRefundInfo: 'Payment or Credit/Refund Info',
  paymentOrRefundMethod: 'Payment or Refund/Credit Method',
  paymentOrRefundStatus: 'Payment or Refund/Credit Status',
  paymentProcessDate: 'Payment Process Date',
  paymentRefundDate: 'Based on Payment/Refund Date',
  payments: 'Payments',
  paymentsAndRefunds: 'Payments & Refunds/Credits',
  paymentSettleDate: 'Payment Settle Date',
  paymentStatus: 'Payment Status',
  payNow: 'Pay Now',
  payrollPreferences: 'Payroll Preferences',
  pdfDocument: 'PDF Document',
  pinAnnouncement: 'Pin Announcement',
  pinned: 'Pinned',
  pending: 'Pending',
  pendingRegistrations: 'Pending Registrations',
  per: 'Per',
  percentage: 'Percentage(%)',
  percentageExplanation:
    '* The percentage-based supplemental fees shown in this report are calculated as a percentage of each child’s regular childcare fees, which vary based on age and registered hours. As a result, these fees differ for each child, and there is no single fixed amount for all families. However, we maintain detailed records of the exact charge for each child, which are available upon request.',
  periodEndDate: 'Period End Date',
  periodStartDate: 'Period Start Date',
  permittedAgeGroups: 'Permitted Age Groups',
  permittedUses: 'Permitted Uses',
  personalAddress: 'Personal Address',
  personalBalance: 'Personal Bal.',
  personalContactInfo: 'Personal Contact Info',
  personWhoGaveMedication: 'Person Who Gave Medication',
  phoneNumber: 'Phone Number',
  physical: 'Physical',
  pickupAuthorization: 'Pickup Authorization',
  pickupDropoff: 'Pickup/Drop Off',
  pickupNotes: 'Pickup Notes',
  pipelineName: 'Pipeline Name',
  platformPayoutAmount: 'Platform Payout Amount',
  pleaseFixTheFollowingErrors: 'Please fix the following errors:',
  pod: 'Pod',
  podMessagesGroup: {
    inUseError: 'Cannot delete transportation group(s) in use',
  },
  pods: 'Pods',
  portal: 'Portal',
  portalForm: 'Portal Form',
  portalMember: 'Portal Member',
  portalUsername: 'Portal Username',
  portalUsernameTooltip:
    'Portal username is linked to personal email, modify the personal email to change the portal username',
  position: 'Position',
  possibleAgeGroups: 'Possible Age Groups',
  postalCode: 'Postal Code',
  preAuthorizedCCPaymentExplanation:
    "Enabling Preauthorized Credit Card Payments allows the center to charge your card when an invoice is due, so you don't have to worry about late payments.",
  preBuilt: 'Pre-Built',
  preBuiltForms: 'Pre-Built Forms',
  preferredName: 'Preferred Name',
  preferredStartDate: 'Preferred Start Date',
  preferredStartDateCannotBeEarlierErrorMessage:
    'Preferred start date cannot be earlier than date of birth',
  preRegistrations: 'Pre-Registrations',
  prev: 'Prev',
  previewBilling: 'Preview Billing',
  previousArrow: '< Prev',
  price: 'Price',
  priceInDollars: 'Price ($)',
  primaryMember: 'Primary Member',
  primaryMemberMustBeLegalGuardian: 'Primary member must be a Legal Guardian',
  primaryTask: 'Primary Task',
  privateNotes: 'Notes (Private)',
  process: 'Process',
  processDate: 'Process Date',
  processed: 'Processed',
  processId: 'Process Id',
  processing: 'Processing',
  profile: 'Profile',
  program: 'Program',
  programAsOfDate: 'Program As Of Date',
  programAvailableCloseDate: 'Program Available Close Date',
  programAvailableOpenDate: 'Program Available Start Date',
  programLearningTheme: 'Program Learning Theme',
  programPlanCategory: 'Program Plan Category',
  programPlans: 'Program Plans',
  programRollover: 'Program Rollover',
  programs: 'Programs',
  programSchedule: 'Program Schedule',
  programStepInstruction:
    'Select the start date and program you want for each child. A child can be registered for multiple programs at once.',
  progress: 'Progress',
  progressGroupDescription:
    'View detailed progress reports for groups across all learning areas',
  progressGroupTitle: 'Group Progress Report',
  progressReports: 'Progress Reports',
  progressStudentDescription:
    'View detailed progress reports for individual students',
  progressStudentTitle: 'Student Progress Report',
  prohibitedFood: 'Prohibited Meal Types',
  province: 'Province',
  public: 'Public',
  publicRegData: 'Public Reg. Data',
  publicRegistration: 'Public Registration',
  publicRegistrationV2: 'Public Registration (V2)',
  publicRegistrations: 'Public Registrations',
  publicRegistrationSessionExpiredMessage:
    'Your session has expired. Please resubmit your registration.',
  publicRegistrationSuccessMessage:
    '{firstName} {lastName} has been placed into the {programName} program with the following status: {status}',
  purpose: 'Purpose',
  qtyPerChild: 'Qty per Child',
  quantity: 'Quantity',
  quickBooksAutoCredit: 'Required: Disable Auto Apply Credits',
  quickBooksAutoCreditMessage:
    "QuickBooks' default behavior to reconcile credit memos against the next invoice is incompatible with the ChildFriendly system. To sync, please sign into your QuickBooks Online account and go to",
  quickBooksAutoCreditMessage2:
    'and toggle off Automatically apply credits, then refresh this page.',
  quickBooksClosed: 'QuickBooks Close Date',
  quickBooksConfig: 'QuickBooks Config',
  quickBooksInitiated:
    'Quickbooks sync has been intiated, and may take some time. You can safely navigate away from this page.',
  quickHelp: {
    orgSetup: {
      successRedirectUrl:
        'Specify a custom URL to redirect users to instead of displaying the standard success page. This is especially useful for tracking conversions with third-party marketing or analytics tools.',
      orgAlias:
        'Shortened name for your organization, will be used in the URL for parents to access their portal. Please contact support to request changes.',
      centerAlias:
        'Shortened name for your center, will be used in the URL for parents to access their portal and in syncing to accounting software. Please contact support to request changes.',
      businessName:
        'The legal name of your business. Will only be shown on legal documents such as tax receipts. Please contact support for changes after initial center creation.',
      businessNumber:
        'The unique number assigned to your organization by the government (assigned by the CRA in Canada and IRS in USA), used for tax purposes and other official interactions, such as filing taxes, managing payroll, or handling accounts. In ChildFriendly, this number will only be shown on legal documents such as tax receipts. Please contact support for changes after initial center creation.',
      setupMode:
        'As families are given access to the parent portal, a welcome email will automatically be sent to them. By enabling setup mode, ChildFriendly will temporarily pause sending these emails. This allows you to complete setup of your center before allowing parents in. When this mode is disabled, all paused welcome emails for families with parent portal access will be sent.',
      feePayments:
        'Your local jurisdiction may allow you to pass the merchant surcharge fee for processing debit or credit card transactions onto the purchaser. These toggles allow you to set the surcharge percentage for pass through to the parents. The surcharge will be added onto the invoice as a Merchant Fee line item when payments are created for Credit Cards or PAD payments.',
      allowCreditCards:
        'Your center may choose whether or not to accept Credit Cards as a method of payment for your families. If Credit Card payments are not enabled, ChildFriendly will not offer this option. The only exception is that families will still be able to pay their registration deposit via the online registration form using a credit card.',
      companyBankAccount:
        'The company bank account must be provided for the center so that ChildFriendly to act as a payment merchant on your behalf. Payments settled for pre-authorized debit (PAD) and Credit Card payments will be deposited to this bank account provided. Please contact support if you need to change your bank account information so we can ensure a smooth transition.',
      locations:
        'Locations that your organization will transport children to and from, primarily schools for before and after school care programs. These will be used later in setup to set transport groups for children to be put in.',
      sponsors:
        "Financial sponsors who are not a part of any family, but are a third party that will be paying fees on behalf of a child. These sponsors can be assigned to billings for families and invoiced automatically for an allocated percentage or amount of the child's monthly tuition. Ex: Government Subsidy Programs.",
      adjustments:
        "Setup any discounts/fees that may be routinely applied to a student's tuition. These adjustments can be set up as either a fixed amount or percentage of the billing amount. Any sponsor in the family can be assigned an adjustment, and it will automatically be applied to their monthly invoice as a line item to reduce/increase the invoice total. Ex: Employee Discount. For one-off discounts, a catalog item is recommended instead, as discounts are primarily intended to work with auto billing for repeating processes.",
      tasks:
        'Create tasks for staff to allocate their labor hours. Staff will select the task they are performing each time they move into a space in the Attendance module. For payroll or government reporting, staff hours will be viewable by tasks. This also allows you to easily apply different pay rates based on the task being performed.',
      catalog:
        'Catalog items represent specific charges that can be added to an invoice. The system automatically applies default items during billing creation. You can create additional items, such as one-time event fees or late payment charges, to be included on invoices as needed, allowing for accurate revenue tracking.',
      users:
        'Add admin users of the platform here, enabling staff members with accounts to log into Child Friendly and access the information they have permissions for. Please note that only admin users can be added here. Regular room staff access is managed through the Staff module, while parent access to the Parent Portal is handled separately in the Families module.',
      adminStaff:
        'Administrative staff have a high level of access to the platform. They are generally able to view, edit, and manage most of the information on the platform. All administration accounts are created and managed on this page. See "Role" for the details on what each specific role can access. ',
      roomStaff:
        "Room staff have limited access to the platform, restricted to only the information necessary for their duties as early childhood educators. They can access the Attendance module, Journals, the Dashboard's RSVP, Regular Meds, and Meals tabs, as well as view-only access to essential child profile details such as allergies, medications, and contacts. The read-only table below provides an overview of who has active Room Staff access to the platform. However, to edit or create these accounts, you must do so under individual staff profiles in the Staff module.",
      role: "Roles define an administrative staff member's permission level to view and manage information within the platform. There are three types of roles available to admin staff, each with increasing levels of access:",
      roles: {
        orgAdmin:
          'Org Admins have full access to view and edit all information across all centers, including the Setup module. This role is ideal for owners and corporate executives. ',
        centerAdmin:
          'Center Admins have similar access to Org Admins but are limited to the centers they are assigned to and do not have access to the Setup module. This role is recommended for upper management staff and finance managers overseeing one or more locations.',
        officeStaff:
          "Office Staff have restricted access, excluding sensitive information such as financial reports and parents' financial details. They can only access the centers they are assigned to and have no access to the Setup module. This role is suitable for general administrative staff within a center.",
      },
      isOvernight:
        'Enabling overnight mode will disable auto signout for attendances at 11PM local time.',
      enableAttendanceKiosk:
        'Enables setting up an attendance kiosk to allow family members to easily pick up/drop off students in their family via PIN code.',
      enableReportAcknowledgment:
        'Enables report acknowledgment functionality to require acknowledgment of incident and illness reports by a family member.',
      allowParentToRoomStaffMessaging:
        'Enables the ability for room staff to view and respond to messages from parents.',
      updatePastAdjustments:
        'Will bulk update the amount of any existing adjustments in the family ledger to the new amounts. Only families exisiting adjustments which are not expired and not custom will be updated.',
      mealsService:
        'Toggle this on if this type is for a meals service you offer. If toggled on, you will be able to filter for this type in the Dashboard -> Meals tab',
      outsideProgram:
        'Toggle this on if you offer a supplemental service that falls outside the scope of your licensed childcare program and should not be included in the Supplemental Fees Report.',
      frequency:
        'Typical frequency this item is applied at to be used for reporting to the government. Is a required property when the adjustment is a fee',
    },
    centerSetup: {
      averagingPeriod:
        "Overtime is averaged over the full period inputted rather than weekly. For example, if '4' is entered, overtime is based on total hours exceeded over a 4 week time span rather than on a weekly basis. If no number is inputted, it will default to a weekly calculation.",
      holidayHours:
        'Enable holidays and holiday hour tracking for staff. When enabled, you can set which days are holidays and configure how holiday hours are calculated based on regional labor standards or custom rules.',
      ageGroupDictionary:
        'Setup the age ranges you want to group students into. Generally, this should follow the regulatory guidelines in your region, as age groups are automatically assessed against the staff-to-child ratio when monitoring attendance. For example, if your Licensing regulations define Toddlers as ages 19 months to 23 months then you would set up that age group here.',
      teamRatioRules:
        'Team ratios are setup for each age group to meet government and licensing requirements for the children in the center. Staff-to-child ratios and max team (group) size will be checked every time students are moved around the attendance module, and warnings will display automatically when any of the limits are exceeded.',
      customization:
        'Customizations allow you to setup messaging and custom fields specific to the needs of your center. These include email templates for online registration, immunization requirements for student records, health symptoms to identify and record, and prohibited foods for meals being served.',
      agreementsAndPolicies:
        "Add any agreements you want the parents to sign. All agreements listed in this tab will be shown to the parents when they log into the parent portal. If the agreement type is mandatory, it will be shown with an asterisk in the portal and must be agreed to by the parent prior to being granted access to the rest of the portal features. ChildFriendly will track everyone who signed the agreements in the student's file folder, and allow you to filter for families who have not signed them through the agreements tag on the families module or on the onboarding dashboard.",
      importData:
        'This tab allows you to import family member, student, and staff data you have from your existing system into ChildFriendly. Start by importing the members using the family template which can be downloaded on the top right. Include the same family email for all members that you wish to be grouped into one family. Then import the students using the student template, using the same family email and they will be added into the existing family. Finally staff information can be imported using the staff template. Contact support during business hours if you would like to be assisted through this process.',
      ageRangeType:
        "Select if the age group should be based on the student's age or grade. Grade based age groups apply to students in out of school care, where registration will require a child's school and grade. Age based groups apply to students pre-kindergarten or younger, where registration will only require a child's birth date. ",
      sendTestEmail:
        'Enter an email address for internal testing and receive a sample email matching what will be sent to parents when they register for a program. This allows you to preview how your customizations will appear to the parents in email format.',
      viewPreview:
        'View a preview of the email that will be sent when parents register for a program. This allows you to preview how your customizations will appear.',
      webFormEmail:
        'When parents register through the public web form or are registered by a staff member, a welcome email will be sent to them inviting them to the parent portal and to complete the remaining required information via the portal. Here you can customize the from email address, the subject line, and the body you want included in the email by filling out the fields below. Note: Your email address will need to be verified by signing into the email account and authorizing Child Friendly to send emails on your behalf after you choose your email.',
      webFormDepositAgreement:
        'When parents register for a program through the public registration form or parent portal, you may require them to pay a deposit, as setup in the Programs tab. The text provided in this section will be shown to the parents as they are making this payment as terms and conditions.',
      prohibitedFood:
        "As part of a child's profile, parents can specify which 'meal types' from your menu their child should not be given, allowing you to offer an alternative when applicable. This feature is distinct from allergy management, as it focuses on entire meal types rather than specific ingredients. For example, if you offer a vegetarian option for children who cannot eat pork, \"Pork\" would be included as a 'Prohibited Meal Type.' This helps you determine how many vegetarian dishes versus pork dishes are needed on a given day. You can define the prohibited meal types parents can select from, creating a dropdown menu for them to choose from when submitting this information. This data will then be accessible in the Dashboard, aiding in menu planning, grocery shopping, and ensuring the correct meal types are provided to the appropriate groups of children.",
      immunization:
        "Enter the list of immunizations you want to track records of for students. The immunizations listed here will be available for parents to select under the child's records while submitting immunization dates.",
      healthSymptoms:
        'To standardize the reporting of health incidents, list all the symptoms you want to be able to create a journal record of. When staff draft a health journal, they will be able to select one or more of the applicable symptoms. There will be additional text fields where staff can enter more information.',
      uploadTaxSignature:
        'Members are able to download a tax receipt for their yearly tuition payments in the parent portal. The electronic signature uploaded here will sign the bottom of the tax receipt provided. This signature should be provided by the owner or an authorized representative.',
      rotessa:
        "Rotessa will be used to process pre-authorized debit (PAD) payments. Submit the required business information below so we can create a client to process your transactions on ChildFriendly's platform. After submission, you will be requested to provide identification. A few days for processing will occur to verify ownership and compliance. Once approval has been provided, you will be able to begin charging parents in ChildFriendly. If you need to update any information after the initial submission, or have questions about the setup process, please reach out to support.",
      stripe:
        'Stripe will be used to process credit card payments for deposits or tuition. Use the links below to go to Stripe and create or update your Stripe connected account. After a connected account is created, you can begin charging credit cards through the platform. Please reach out to support if you require any assistance.',
    },
    spaceSetup: {
      tab: 'Spaces are physical rooms or spaces in the center which will be used for tracking attendance. Any spaces defined here will be able to have students or staff moved into them in the attendance module. Additionally, transport spaces such as buses for out of school care or field trips should be set up to fully encompass attendance tracking. For example, you may want to create a space called "Field Trip" so that when children are transported to a field trip, they will show up in the \'Field Trip\' space, where you can easily see who is on the field trip at a glance. ',
      color:
        'Color code to assist with organizing your spaces as desired. The chosen color will be shown beside the space in the attendance list and as a colored dot on the attendance map.',
      type: 'The type of activity typically performed in the space. If Walking or Bus are selected as a type, the space will be set up as a transport space.',
      abbreviation:
        'A shortened name for the space which will be used on the attendance map. By abbreviating the name, it will keep your attendance map clear. ',
      task: 'The typical task a staff member will perform in the space. When a staff member signs into the space it will default them to this task, however they can override the selection as part of the sign in process. For example, a homeroom may have a task called "Childcare" as the default assigned task, whereas the Office may have \'Admin\' as the default task. ',
      permittedUses:
        'A permitted use defines what age groups, license and how many children are permitted by the center or their licensing regulations in the space at a given time. You can have multiple permitted uses. If any students in the space do not fit into one of the permitted uses, the attendance module will indicate red a warning on the space. You should list all permitted uses a space is licensed for. ',
      licenseType: 'PLEASE REMOVE THIS "?"…it is redundant. ',
      maxCapacity: 'PLEASE REMOVE THIS "?"…it is redundant. ',
      permittedAgeGroups: 'PLEASE REMOVE THIS "?"…it is redundant. ',
    },
    reports: {
      payroll:
        'The average hours the employee worked based on the holiday pay calculation strategy selected in Setup > Center > Customizations under Payroll Preferences. These hours are not included in Total Hours Worked.',
    },
    groupSetup: {
      tab: 'Groups are used to organize children into classes or cohorts. They are used to determine the licensed capacity and available spaces within the center. Students can only be registered into groups if they fall within the defined age ranges specified in this section. For example, if you occasionally include Toddlers in a Preschool group, be sure to include the Toddler age range in that group; otherwise, you will not be allowed to place Toddlers in it. ',
      licenseType:
        'The type of license to apply to this group. Only student which are suitable for the license can be enrolled in the group. ',
      homeSpace:
        'The home room space the students will spend time in. This field is for your tracking purposes only, there are no restrictions where students can move based on this field.',
      maxCapacity:
        'The maximum number of students allowed to enroll in the group. This limit will drive the SMART registration system that identifies the number of current registrations against the  licensed space capacity of your center at any given point in time. When a group has the maximum number of students as of an applicable date, ChildFriendly will automatically waitlist all new registrations against the group that is full. Admins are able to override the setting and put additional children into the group if desired, but parents cannot via the online registration. If this group is listed on multiple programs, the single capacity will be shared by all programs.',
      napping:
        'A toggle to indicate if the group is set up for nap time. This allows parents to select the appropriate group during registration based on whether their child to naps or not.',
      ageGroups:
        'The age groups which are allowed to be enrolled into this group. This is used for both the SMART registration system and administrative staff, no one will be allowed to register/enroll a student in a group if they do not match an age group defined here on the start date. Children can temporarily exceed the age group if they age out before their registration ends, as long as they were allowed in the program on the start date.',
    },
    rateSetup: {
      tab: 'Rates are applied to registrations and determine how much a child will be automatically charged on their automatic tuition billing.',
      ageGroups:
        'The age groups this rate is meant to apply to. Parents registering through the public web form will be restricted to rates that match the age group of the child. The SMART registration system will use these age groups to recommend rates as part of the auto-generated registration proposals.',
      billing:
        'The amount the student will automatically be billed for registrations using this rate. Currently, we only support monthly billings and one off custom billings. Note: Child Friendly is actively working on the design and support for shorter and custom time periods which will be released at a later date.',
      credits:
        'Determine if the rate is for a full time or part time student. When part time is selected, identify the number of part-time days, then each registration this rate is used on will need to select which days of the week the child will be present. These are the only days the student will be considered for when determining capacity in the program.',
      rollOver:
        "Rollover provides two methods to automatically change a student's rate. Method 1: The graduate rate will apply whenever a student ages out of the age groups set on this rate, the month after that happens the student will be billed at the graduate rate (Ie. An Infant that becomes a Toddler will automatically graduate to the Toddler rate). Method 2: The change date allows you to change the rates for all children to a different rate on a specific date. Ex. yearly increases in tuition. On the change date this rate will be archived and registrations which use it will start being billed at the new rate for the next billing.",
    },
    programSetup: {
      tab: 'Programs are the comprehensive childcare plans which combine rates, groups, and scheduling for student registration. Programs are simply what parents will register into and they drive what options are available for them via the Online Registration form. Programs let our SMART registration system know what proposals to make, when parents can enroll, and how much it costs to register.',
      registrationAges:
        'Specify the age groups eligible to register for the program. The public registration form will only allow students within these age groups to enroll. Administrative staff can register a child in any program, but the recommended programs will be based on these age groups. While you can allow multiple age ranges within a group to offer flexibility in operations, you may choose to restrict age groups more strictly within programs. This ensures that only new registrations from the online form fall within the desired age range. For example, you might have a Preschool group that includes both Preschool and Pre-K children, allowing Preschool children to transition within the group as they age. However, under programs, you may restrict new registrations to only Preschool-aged children, with a separate program for Pre-K.',
      registrationGroups:
        'What groups are able to register in the program. The public registration system will select an applicable group to give the child as a pending registration, based on the program selected. The administrative staff can override the group to any group the child is allowed into, but the recommended groups will be based on what is listed in the program.',
      rates:
        'What rates are allowed for the program. The part time/full time frequencies available to parents in the public registration form will be based on the rates listed for the selected program. The administrative staff can override the rate to any rate, but the recommended rates will be based on what is listed in the program.',
      registrationDeposit:
        'The amount you want parents to pay to reserve a spot in the program. When a parent goes through the online public registration form and there is space available, they will be prompted to pay this amount as a deposit by credit card before their registration is created.',
      waitlistDeposit:
        'The amount you want parents to pay to reserve a spot on the waitlist. When a parent goes through the public registration form and there is no space left, they will be prompted to pay this waitlist deposit amount by credit card. ',
      openDate:
        'The date the program will start being run in the center. When creating a registration at a point in time, if the start date is not between the program open and closed dates then the program will not be included in the list of available programs as recommended by the SMART registration system.',
      openDatePublic:
        'The date this program will be available for the public, generally new families, to register in this program. If a parent goes to the public registration form embedded on your website before this date, then this program will not be shown as an option they can register into. If no date is set, the program will always be available.',
      openDatePortal:
        'The date this program will be available for existing parents that have access to the parent portal to register in this program. You may choose to set this date earlier than the public registration date to give existing parents priority access to the program. On the parent portal, this program will not be shown until the portal open date. If no date is set, the program will always be available for registration on the parent portal.',
      registrationInAdvance:
        'This feature allows you to limit the number of weeks in advance parents are able to register for a program. When a parent goes to register, if the start date they select is more than this many weeks in the future from today (including 0), they will automatically be given a waitlist option instead, even if there is still space in the program. Use this feature to prevent parents from registering children years into the future.',
      rollOver:
        "The program rollover drives the SMART registration system to propose future registrations for students as they age out of their current program. When the system generates registration proposals, it will check on the change date to determine if each student still qualifies for the program and group they are registered in. This date can be specific dates or the same day recurring every year. Typically, it is recommended that you select a date like Sept 1 when students may be rolling over from daycare to out of school care programs. If the child does not qualify for the program they are currently in after the change date, then they will be proposed either the Next Program or Kinder Program indicated as their rollover program. If they do not qualify for this rollover program, it will continue to check this rollover program's following rollover program until it finds an applicable program or runs out of options. This option does not automatically change any children's registrations, it serves to set parameters for the SMART registration program to propose what following options are available in the future for your staff to accept and modify until they are happy with them. Please contact support if you have any additional questions about how the rollover feature works.",
      kinderProgram:
        'This program will be used as the rollover program for when you have a child that will move from an age based program to a grade based program I.e. when children generally begin Kindergarten. Please select the kinder program you want students to be rolled into. This option only needs to be filled out for programs that would typically have children graduating from their age based program (ie. Pre Kinder) into a kindergarten or grade based program. Otherwise, you will always use the Next Program (age to age or gr. to gr.) field to determine the rollover program. ',
    },
    transportSetup: {
      transportSpaces:
        'These are the transport spaces setup in the space tab. They are shown as a read only copy here for reference while setting up transport groups. ',
      transportGroups:
        "A transport group is used to group children who are typically transported together, ex. children that all load onto the same bus each morning, even if from different schools or maybe you transport all your Afternoon Kinders from multiple schools, altogether. The transport group will be set on the student's registration and can be filtered for in the attendance module to easily bulk select students to sign in and out. ",
    },
    schoolSetup: {
      available:
        'Sets if the school should be available to register in. If a school is set to not available, then it will not show up as an option for parents on the public registration form, or for staff when creating/editing registrations. ',
      gradesSchool:
        'All the grades that the school offers. This will be used to determine what options parents/staff can select for grades when creating registrations.',
      gradesGroup:
        'The grades which should be allowed to join this transport group. When staff are selecting what transport group a registration should be assigned, they will only be shown transport groups that the student has a matching grade for. ',
      transportGroup:
        'Which transport group set up in the transport tab will be used to transport children to the school. One transport group can be used to transport to multiple schools, so you are allowed to list the same transport group under as many schools as you wish.',
      schedule:
        'Which days the transport group will be going to the school. If you set up only specific days, then this transport group will only be shown as an option when the registration includes these days. ',
    },
    emailSendTo: {
      child: 'Email will send to the guardians of the selected child(ren).',
      member: 'Email will send to the selected members.',
      staff: 'Email will send to the selected staff.',
      group:
        'Email will send to the guardians of the children within the selected group.',
      program:
        'Email will send to the guardians of the children within the selected program.',
    },
    student: {
      mealRestrictions:
        "Meal types from the center's menu that the student cannot eat due to allergies, religious, or personal restrictions.",
      preferredName:
        'In Attendance, the Preferred Name is used for students signed into a space. If two students share the same first name, you can enter a preferred name here to distinguish between them. Any changes to this field will take effect once the student signs out or is moved.',
    },
    member: {
      primaryMember:
        'The primary member is usually the individual who registered the student. If this needs to be changed, it can only be updated by the center administrator.',
      portalMember:
        'Portal access for additional members can be granted by the center. Once enabled, members will only be able to view basic profile information for other members. They will not have access to any financial or payment details other than their own.',
      authorizedSponsor:
        "Enable this option for any member who will be responsible for paying all or part of the child's fees. The center can only accept payments from individuals who have been designated as authorized sponsors.",
    },
    kioskSetup: {
      enableSpaceForDropOff:
        'Enabling this setting on for the space will allow it to appear as a possible drop-off location for the authorized family member in the Attendance Kiosk.  This does not affect pickup.  Note that spaces with no defined permitted uses are not allowed for drop-off.',
    },
    feeCollection: {
      privateMemo:
        "This memo will not be shown to the centers. It is internal for ChildFriendly's use.",
      publicMemo:
        'This memo will not be visible to the centers. Indicate anything you want them to know about.',
    },
    messaging: {
      activeGroups:
        'A group is considered active if it has a staff member currently assigned to it, or a staff member signed into a room that has a student from this group in attendance.',
      includeUnread:
        'When enabled, any family with unread messages will appear in the list, even if they do not match the current filters.',
    },
  },
  range: 'Range',
  rangeType: 'Range Type',
  rate: 'Rate',
  rateAsOfDate: 'Rate As Of Date',
  rates: 'Rates',
  rateType: 'Rate Type',
  ratioNapping: 'Napping Ratio',
  ratioStandard: 'Standard Ratio',
  read: 'Read',
  reason: 'Reason',
  reasonForAbsence: 'Reason for Absence',
  reasonForSkipping: 'Reason for Skipping',
  recheck: 'Recheck',
  recheckStatus: 'Recheck Status',
  recipientEmail: 'Recipient Email',
  recipientFamilyName: 'Recipient Family Name',
  recipientFirstName: 'Recipient First Name',
  recipientLastName: 'Recipient Last Name',
  recipientName: 'Recipient Name',
  recipients: 'Recipients',
  reconcile: 'Reconcile',
  records: 'Records',
  recovery: 'Recovery',
  recoveryInvoice: 'Recovery Invoice',
  recurring: 'Recurring',
  recurringWeekly: 'Recurring Weekly',
  refresh: 'Refresh',
  refreshAttendanceList: 'Refresh attendance list',
  regInAdvance: 'Reg. In Advance',
  regionSpecific: 'Region Specific',
  registration: 'Registration',
  registrationAgeGroups: 'Registration Age Groups',
  registrationAges: 'Registration Ages',
  registrationBillingDate: 'Based on Registration/Billing Date',
  registrationCloseDate: 'Registration Close Date (Public)',
  registrationCloseDatePortal: 'Registration Close Date (Portal)',
  registrationComplete: 'Registration Complete!',
  registrationCompleteMessage:
    'Your {childrenText} been successfully registered. No payment is required at this time.',
  registrationDate: 'Registration Date',
  registrationDeposit: 'Registration Deposit ($)',
  registrationEndDate: 'Registration End Date',
  registrationGroups: 'Registration Groups',
  registrationLocation: 'Registration Location',
  registrationOpenDate: 'Registration Open Date (Public)',
  registrationOpenDatePortal: 'Registration Open Date (Portal)',
  registrationProposals: 'Registration Proposals',
  registrations: 'Registrations',
  registrationSetsSchool: 'Registration Sets School',
  registrationSlots: 'Slots',
  registrationStartDate: 'Registration Start Date',
  registrationTags: 'Registration Tags',
  regularMeds: 'Regular',
  reject: 'Reject',
  rejectConfirmation:
    'Are you sure you want to reject this {name}? You can optionally provide feedback below.',
  rejected: 'Rejected',
  rejectedAssessments: 'Rejected Assessments',
  rejectedDate: 'Rejected Date',
  rejectInfoChangeConfirmationMessage:
    'Rejecting will discard the requested info changes. Are you sure you want to continue?',
  rejectionReason: 'Rejection Reason',
  rejectionReasonPlaceholder: 'Reason for rejection...',
  rejectLesson: 'Reject Lesson',
  rejectLessonConfirmation:
    'Are you sure you want to reject this lesson? You can optionally provide feedback below.',
  relationship: 'Relationship',
  relationshipToStudentBeingRegistered:
    'Relationship To Student Being Registered',
  rememberEmail: 'Remember email',
  reminder: 'Reminder',
  reminderBanner:
    'Please add and keep updated all student (allergies, medications etc), guardian and other contacts info via the Members and Students tabs. If another member would like to have their own Portal login, add them in the Members tab, then email your request for portal access to administration.',
  remove: 'Remove',
  removeChild: 'Remove Child',
  move: 'Move',
  rename: 'Rename',
  repeat: 'Repeat',
  repeatEvery: 'Repeat every',
  report: 'Report',
  reportAcknowledgment: 'Report Acknowledgment',
  reportDate: 'Report Date',
  reportDateFrom: 'Report Date From',
  reportDateTo: 'Report Date To',
  reportDetails: 'Report Details',
  reports: 'Reports',
  reportsDescription:
    'Access comprehensive reports to track student and group learning progress',
  requestApproval: 'Request Approval',
  requestedStartDate: 'Requested Start Date',
  require: 'Require',
  required: 'Required',
  requiredForFees: 'Required for Fees',
  requiredSpaceRatio: 'Required Space Ratio',
  rerollPIN: 'Reroll PIN',
  resendDepositRequest: 'Resend Deposit Request',
  resendOneTimePasscodePrompt: 'Resend one time passcode?',
  reserved: 'Reserved',
  reset: 'Reset',
  resetAll: 'Reset All',
  resetAmount: 'Reset Amount',
  resetPasswordButtonLabel: 'Reset password',
  resetPasswordCheckboxLabel: 'Reset Password',
  restore: 'Restore',
  resultingAttendances: 'Resulting Attendance History will be:',
  return: 'Return',
  returnCredit: 'Return Credit as payment',
  returningToMainMenuWarning: 'Returning to Main Menu in {timeLeft}...',
  returnToMainMenuButtonLabel: 'Return To Main Menu',
  reviewDate: 'Review Date',
  reviewSignInMessage: 'Review and confirm the selected staff and students',
  revokeAuthorizationFromDeviceLabel: 'Revoke authorization from device',
  revokeAuthorizationFromDeviceTooltip:
    'Remove authorization from this device to prevent non-admin users from using this device.',
  revokeDeviceAuthorizationErrorMessage: 'Error revoking device authorization',
  rightClickForActions: 'Right click to perform actions',
  role: 'Role',
  rollOver: 'Roll-Over',
  rollOverAgeGroups: 'Roll-Over Age Groups',
  roomStaff: 'Room Staff',
  rotessa: 'Rotessa',
  rotessaAccountSetup: 'Rotessa Account Setup',
  rotessaAccountSetupDescription:
    "Rotessa is the payment processor used by ChildFriendly to withdraw payments directly from your customer's bank account when they are due. Please review the details below and proceed with submission.",
  rotessaAccountSetupVerification:
    'Please verify the detail to connect with and submit below',
  rotessaAgreement: "By clicking Create Rotessa Client you agree to Rotessa's",
  rotessaBusinessInfo:
    'The following Center information will used for the Rotessa account setup. If any of this information is incorrect, please update it under the Organization -> Centers tab',
  rotessaConfig: 'Rotessa Config',
  rotessaConfirmation:
    "Information cannot be edited during the verification process. Please confirm that you have included accurate information for all owners/shareholders of more than 25% equity or, if the entity is run by a board (where there is no ownership or shares), that all board members have been listed. Additionally, ensure that either a void check or a direct deposit form, along with the last month's bank statement, have been uploaded and match the bank account set under the Business Info section.",
  rotessaCreate: 'Create Rotessa Client',
  rotessaInfoOnFile: 'Information on file with Rotessa',
  rotessaModification:
    'To modify information after submission, please contact support through chat or email at',
  rotessaOwnerInfo:
    'Please list each owner/shareholder of more than 25% equity. If the entity is run by a board, where there is no ownership or shares, list all board members.',
  rotessaSetup: 'Rotessa Setup',
  rotessaTesting: 'Rotessa (Testing)',
  roundingOptions: 'Rounding Options',
  routine: 'Routine',
  routines: 'Routines',
  rsvpType: 'RSVP Type',
  sandboxMode: 'Sandbox Mode',
  save: 'Save',
  saveChangesWarning:
    'Saving these changes will clear out excluded and modified dates.',
  schedule: 'Schedule',
  scheduledAdminTime: 'Sch. Admin Time',
  schedules: 'Schedules',
  school: 'School',
  schoolMessagesGroup: { inUseError: 'Cannot delete school(s) in use' },
  schools: 'Schools',
  recent: 'Recent',
  recentActivity: 'Recent Activity',
  search: 'Search',
  searchBySponsorOrChild: 'Search by sponsor or child',
  searchConversations: 'Search conversations...',
  searchDirectMessages: 'Search direct messages...',
  searchFamilies: 'Search Families...',
  searchFamiliesOrStaff: 'Search families or staff...',
  searchGroups: 'Search groups...',
  searchGroupsByName: 'Search Groups By Name...',
  searchMessages: 'Search messages...',
  searchResults: 'Showing search results',
  selectAll: 'Select All',
  selectAtLeastOneDay: 'You must select at least one day.',
  selectDate: 'Select Date',
  selectGroup: 'Select Group',
  selected: 'Selected',
  selectGroupForFAReport:
    "Monitor groups progress towards focus areas based on the lesson's they have completed",
  selectGroupForShoppingList: 'Select a group to view their shopping list',
  selectedSignedInAttendeeCountMessage: 'Selected Signed In Attendees: {count}',
  selectedSignedOutStaffCountMessage: 'Selected Signed Out Staff: {count}',
  selectedSignedOutStudentsCountMessage:
    'Selected Signed Out Students: {count}',
  selectedStaffCountMessage: 'Selected Staff: {count}',
  selectedStudentsCountMessage: 'Selected Students: {count}',
  selectFamilyMembersToSendBulkMessages:
    'Select family members to send bulk messages',
  selectMultiple: 'Select Multiple',
  selectOrgFirstPrompt: 'Please select an organization first',
  selectOutcome: 'Select a Learning Outcome',
  selectOutcomePrompt:
    'Choose a learning outcome from the sidebar to view and manage assessments',
  selectSchedule: 'Select schedule to check availability',
  selectStaff: 'Select Staff',
  selectStudent: 'Select a student to drop-off or pick-up',
  selectStudentForFAReport:
    "Monitor students progress towards focus areas based on the lesson's they have completed",
  selectStudents: 'Select Students',
  selectTeams: 'Select Teams',
  send: 'Send',
  sendAnnouncement: 'Send Announcement',
  sending: 'Sending',
  sendingAs: 'Sending as',
  sendingBroadcast: 'Sending broadcast...',
  sendUrgent: 'Send Urgent',
  sendNow: 'Send Now',
  sendResetPasswordEmailMessage:
    'We sent a password reset link to the registered account with email if it exists.',
  sendTestEmail: 'Send Test Email',
  sendToAll: 'Send to All',
  sendVerificationEmail: 'Send Verification Email',
  sent: 'Sent',
  sentToRecipients: 'Sent to {count} recipients',
  seriesDetails: 'Series Details',
  seriesEndDate: 'Series End Date',
  seriesEndDateMustBeAfterStart: 'Series end date must be after the start date',
  seriesStartDate: 'Series Start Date',
  setNewPasswordPrompt: 'Set new password',
  settings: 'Settings',
  settleByCreatingInvoice: 'Settle By Creating Invoice',
  settlement: 'Settlement',
  settlementDate: 'Settle Date',
  settlePayment: 'Settle Payment',
  setup: 'Setup',
  setupMode: 'Setup Mode',
  setupNeeded: 'Setup Needed',
  shared: 'Shared',
  shareLinkPrompt: 'Or share this link:',
  shoppingList: 'Shopping List',
  shoppingListReports: 'Shopping List Reports',
  shoppingGroupTitle: 'Group Shopping List',
  shoppingGroupDescription:
    'Generate a shopping list for materials needed for upcoming plans in a group',
  shortcuts: {
    chromeTitle: 'Chrome:',
    chromeWinLin: 'Windows/Linux: Ctrl + Shift + R',
    chromeMac: 'Mac: Cmd + Option + R',
    firefoxTitle: 'Firefox:',
    firefoxWinLin: 'Windows/Linux: Ctrl + Shift + R',
    firefoxMac: 'Mac: Cmd + Option + R',
    edgeTitle: 'Edge:',
    edgeWinLin: 'Windows/Linux: Ctrl + Shift + R',
    safariTitle: 'Safari:',
    safariMac: 'Mac: Cmd + Option + R',
  },
  shortName: 'Short Name',
  showAll: 'Show all',
  showAllRecords: 'Show All Records',
  showDetails: 'Show Details',
  showBankInfoLabel: 'Show bank info',
  showEnded: 'Show Ended',
  showFilteredItemsOnly: 'Show Filtered Items Only',
  showFullBreakdown: 'Show Full Breakdown',
  showing: 'Showing',
  showPIN: 'Show PIN',
  showWeekends: 'Show Weekends',
  sickOrIllness: 'Sick / Illness',
  signin: 'Sign In',
  signMultiplePeopleInConfirmationMessage:
    'Are you sure you want to sign {count} people into the {toSpace} space?',
  signMultiplePeopleOutConfirmationMessage:
    'Are you sure you want to sign {count} people out of the {fromSpaces}?',
  signOnePersonInConfirmationMessage:
    'Are you sure you want to sign 1 person into the {toSpace} space?',
  signOnePersonOutConfirmationMessage:
    'Are you sure you want to sign 1 person out of the {fromSpace}?',
  signout: 'Sign Out',
  socialEmotional: 'Social & Emotional',
  socialInsuranceNumber: 'SIN',
  someStudentsAreNotCurrentMessage:
    'Some students selected do not have current status. New journals can only be created for current students.',
  source: 'Source',
  sourcePaymentAmount: 'Source Payment Amount',
  space: 'Space',
  spaceColor: 'Space Color',
  spaceIsEmpty: 'Space is empty',
  spacePlaceholder: 'Select a space...',
  spaces: 'Spaces',
  specialNeeds: 'Special Needs',
  sponsor: 'Sponsor',
  sponsorForRemainingAmount: 'Sponsor For Remaining Amount',
  sponsorName: 'Sponsor',
  sponsorNameLabel: 'Sponsor Name',
  sponsorType: 'Sponsor Type',
  sponsorSelection: 'Sponsor Selection',
  sponsors: 'Sponsors',
  staff: 'Staff',
  staffId: 'Staff ID',
  staffOrAdminViewOnly: 'Staff/Admin View Only',
  staffRoles: 'Staff Roles',
  standaloneFormMessage:
    'Please select your desired location below. If space is not available, you will be automatically directed to add your family to our waitlist.',
  standard: 'Standard',
  start: 'Start',
  startDate: 'Start Date',
  startDateAndTime: 'Start Date and Time',
  startDateCannotBeAfterEndDate: 'Start date cannot be after end date.',
  startDateCannotBeAfterExpiryDate: 'Start date cannot be after expiry date.',
  startDateMustBeEarlier: 'The start date must be earlier than the end date.',
  startingProgram: 'Starting Program',
  startNap: 'Start Nap',
  startNewConversation: 'Start new conversation',
  startTheConversation: 'Start the conversation...',
  startTime: 'Start Time',
  state: 'State',
  stateProvince: 'Province',
  status: 'Status',
  statusAsOfDate: 'Status As Of Date',
  step1: 'Step 1',
  step2: 'Step 2',
  stripe: 'Stripe Account',
  stripeAccount: 'Stripe Account',
  student: 'Student',
  studentFirstName: 'Student First Name',
  studentId: 'Student ID',
  studentInfoChangesLabel: 'Student Info Changes',
  studentLastName: 'Student Last Name',
  studentName: 'Student',
  studentReport: 'Student Report',
  studentReportFilter: 'Student Report Filter',
  students: 'Students',
  studentsSignedIn: '{count} student(s) signed in',
  studentStatus: 'Student Status',
  studentStatuses: 'Student Statuses',
  studentSubStatusTags: 'Student Sub Status Tags',
  studentTags: 'Student Tags',
  style: 'Style',
  subject: 'Subject',
  submit: 'Submit',
  submitAll: 'Submit All',
  submitAndCertify: 'Submit and Certify',
  submitAndReject: 'Submit and Reject',
  submitAndRequestApproval: 'Submit and Request Approval',
  submitOverride: 'Submit Override',
  submitPayment: 'Submit Payment',
  submitRefund: 'Submit Refund',
  subStatusTags: 'Sub Status Tags',
  success: 'Success',
  successRedirectUrl: 'Success Redirect URL',
  suffixes: { st: 'st', nd: 'nd', rd: 'rd', th: 'th' },
  superAdmin: 'Super Admin',
  symptom: 'Symptom',
  sync: 'Sync',
  syncCancelled: 'Sync Cancelled',
  syncFailed: 'Sync Failed',
  syncFrom: 'Sync From',
  syncSettings: 'Sync Settings',
  syncSucceded: 'Sync Succeded',
  syncWarning: 'Sync Completed with Errors',
  systemDefault: 'System Default',
  tabNotFoundMessage: 'This page does not exist.',
  tags: 'Tags',
  tapStudentsToSignIn: 'Tap each student below to sign them in/out',
  targetGroups: 'Target Groups',
  targetingAndOptions: 'Targeting & Options',
  targetRoles: 'Target Roles',
  task: 'Task',
  taskInfo: 'Task Info',
  tasks: 'Tasks',
  taxReceipts: 'Tax Receipts',
  teamPromptTitle: 'Pick an Action for {name}',
  teamRatioRules: 'Ratios',
  template: 'Template',
  templateType: 'Template Type',
  terminationDate: 'Termination Date',
  termsAndConditions: 'Terms and Conditions',
  textColor: 'Text Color',
  thankYou: 'Thank you!',
  thankYouForSubmission: 'Thank you for your submission.',
  theme: 'Theme',
  thisActionCannotBeUndone: 'This action cannot be undone.',
  thisEvent: 'This event',
  time: 'Time',
  timeIdentified: 'Time Identified',
  timeInOutMove: 'Time In/Out/Move',
  timesToBeAdministered: 'Admin Times',
  timeZone: 'Time Zone',
  title: 'Title',
  to: 'To',
  toDate: 'To Date',
  today: 'Today',
  toggleAttendancePanel: 'Toggle Attendance Panel',
  token: 'Token',
  tokenExpired: 'Token Expired',
  total: 'Total',
  totalBilling: 'Total Billing',
  totalChargebackAmount: 'Total Chargeback Amount',
  totalChargebackPaymentFee: 'Total Chargeback Fee',
  totalCurrentAutoBilling: 'Total Current Auto Billing',
  totalDeposit: 'Total Deposit',
  totalFailedPaymentFee: 'Total Failed Fee',
  totalPayment: 'Total Payment',
  totalPaymentAmount: 'Total Payment Amount',
  transactionType: 'Transaction Type',
  transitNumber: 'Transit Number',
  transport: 'Transport',
  transportGroup: 'Transport Group',
  transportGroups: 'Transport Groups',
  transportSpaces: 'Transport Spaces',
  triggerBy: 'Trigger By',
  tryAdjustingFilters: 'Try adjusting your filters',
  type: 'Type',
  typeMessage: 'Type a message...',
  typeYourMessage: 'Type your message...',
  typicalBreak: 'Typical Break (Minutes)',
  unassignedBalance: 'Unassigned Bal.',
  uncancelEnrollmentButtonLabel: 'Uncancel Enrollment',
  unHide: 'Unhide',
  uniqueAgeGroupError: 'Age Dictionary name must be unique.',
  unit: 'Unit',
  unmuteNotifications: 'Unmute Notifications',
  unread: 'Unread',
  unsignedMedicationsBannerMessage:
    '{studentName} has one or more medication(s) that require your approval due to a staff member adding or updating their medication information.  Please review the updated medication information for your child, make changes if necessary, and save the changes to inform the center of your approval.',
  untilDate: 'until {date}',
  untilWithdraw: 'Until Withdraw',
  upcomingRegistrations: 'Upcoming Registrations',
  update: 'Update',
  updated: 'Updated',
  updateOverride: 'Update Override',
  updateOverrideNotes: 'Update the override notes for this report.',
  updatePast: 'Update Past',
  upload: 'Upload',
  uploadAt: 'Upload At',
  uploadEmailSignature: 'Upload Email Signature',
  uploadFiles: 'Upload File(s)',
  uploadImmunizationFile: 'Upload Immunization File',
  uploadPathMissing: 'Missing upload path.',
  uploadPhotosButtonLabel: 'Upload photos/files',
  uploadTaxSignature: 'Upload Tax Receipt Signature',
  uploadUrlFailed: 'Failed to get upload URL.',
  urgent: 'Urgent',
  urgentMessage: 'Urgent Message',
  url: 'Url',
  urlCopied: 'Url Copied to Clipboard',
  useCustomEmail: 'Use Custom Email?',
  username: 'Username',
  users: 'Users',
  userTable: {
    errors: {
      minimum_one_org_admin: 'At least one organization admin is required',
    },
  },
  vacationOrHoliday: 'Vacation / Holiday',
  value: 'Value',
  veriffMessage:
    'You will be redirected to Veriff to supply identification. This only needs to be completed once by the owner with the highest stake in the company, or if run by a board, the board chair, or treasurer.',
  veriffRedirect: 'Redirect to Veriff',
  verificationConfirmation:
    'A verification email will be sent to the provided email, please make sure this email is valid.',
  verify: 'Verify',
  verifyBusinessInformation:
    'Please ensure business information is correct before saving',
  verifyEmail: 'Please verify your email first before sending emails',
  verifyOwner: 'Verify Owner',
  verifyRotessa: 'Verify Rotessa Owner',
  verifyRotessaSandbox: 'Approve Sandbox Acount',
  versionHistory: 'Version History',
  versionNotice: 'You are viewing a past version',
  view: 'View',
  viewEvent: 'View Event',
  viewGroupReport: 'View Group Report',
  viewingEventInstanceMessage:
    'You are viewing an instance of an event in a series.',
  viewMemberProfile: 'View member profile',
  viewOrModifySeries: 'View/Modify Series',
  viewOutcomes: 'View Outcomes',
  viewPIN: 'View PIN',
  viewPreview: 'View Preview',
  viewRecurringDetails: 'View Recurring Details',
  viewSeries: 'View Series',
  viewShoppingListForGroup: 'View shopping list for this group',
  visibility: 'Visibility',
  voidCheck: 'Void Check',
  volunteerExpiryDate: 'Volunteer Expiry Date',
  voPayAccountSetup: 'VoPay Account Setup',
  voPayAccountSetupDescription:
    'VoPay is the payment processor used by ChildFriendly to handle Interac E-Transers. Please review the details below and proceed with submission.',
  waitlist: 'Waitlist',
  waitListDeposit: 'Waitlist Deposit ($)',
  wantToUseADifferentEmailOrCenterPrompt:
    'Want to use a different email or center?',
  wantToUseADifferentEmailPrompt: 'Want to use a different email?',
  warningEditsToSeries:
    'Any edits to the series will remove any individual event modifications.',
  weatherOrTransport: 'Weather / Transport Issue',
  webForm: 'Web Form',
  webFormDepositAgreement: 'Web Form Deposit Agreement',
  webFormEmail: 'Web Form Email',
  webFormRegistration: 'Web Form Registration',
  webOutdated:
    "Please clear your browser's cache and reload this page. You can use the following shortcuts to clear the cache and reload this page:",
  week: 'Week',
  weekOf: 'Week Of',
  weeks: 'Weeks',
  weekly: 'Weekly',
  welcomeToChildFriendly: 'Welcome!',
  whatIsPAD: 'What is PAD?',
  whatIsPreAuthorizedCCPayment: 'What is Pre-Authorized Credit Card Payment?',
  whenToManage: 'When To Manage',
  whichUserAreYouPrompt: 'Which of the following describes you?',
  willAddMoves:
    'Will add the following entries to correct the history of moves',
  willChangeLogs: 'Will modify the following logs',
  withAvailableCredits: 'With Available Credits',
  withdrawalDate: 'Withdrawal Date',
  workAddress: 'Work Address',
  workContactInfo: 'Work Contact Info',
  writeAMessage: 'Write a message...',
  year: 'Year',
  yearEnd: 'Year End',
  yearly: 'Yearly',
  years: 'Years',
  yes: 'Yes',
  yesterday: 'Yesterday',
  you: 'You',
  reply: 'Reply',
  viewProfile: 'View Profile',
  debug: {
    formButton: 'Open form debug',
    formState: 'Form State',
    close: 'Close',
    summary: 'Summary',
    values: 'Values',
    errors: 'Errors',
    meta: 'Meta',
    isSubmitting: 'Is Submitting',
    canSubmit: 'Can Submit',
    dirtyFields: 'Dirty Fields',
    totalErrors: 'Total Errors',
    errorFields: 'Error Fields',
    none: 'None',
    refresh: 'Refresh',
  },
  actionSummary: 'Completed Actions',
  checkedInTo: 'Checked in to {space}',
  checkedOutFrom: 'Checked out from {space}',
  checkingAvailability: 'Checking availability...',
  selectStudentsToSignInOut: 'Select students to drop-off or pick-up',
  clickSignInOutButtons:
    'Click the Pick Up or Drop Off button for each student',
  studentsModified: '{count} student(s) modified',
  currentlyCheckedOut: 'Currently checked out',
  signIn: 'Sign In',
  noChangesTitle: 'No Changes Made',
  noChangesMessage:
    "You haven't signed any students in or out yet. Click the Pick Up or Drop Off button for each student you want to modify.",
  exitAnyway: 'Exit Anyway',
  pickUp: 'Pick Up',
  dropOff: 'Drop Off',
}
